/* eslint-disable  */
/* eslint-disable import/no-unresolved */
import moment from "moment";
import { JointLifeDetails } from "src/redux/Reducers/jointLifeAddendum/interface";
import { ProposerDetails } from "src/redux/Reducers/proposerDetails/interface";
import { ILoanDetails } from "src/redux/Reducers/loanDetails/interface";
import { OPTIONS as NaionalityOptions } from "../Dashboard/resources";
import {
  AddressDetails,
  GeneralDetails,
  IExistingLifeCover,
  NomineeFields,
  ProportionateFields,
  SecondaryDetails,
  familyMedicalData
} from "./ProposalDetails/interfaces";
import { existingLifeCoverInitialValuesObject } from "./LoanDetails";
import { nomineeIndividualField } from "./ProposalDetails/Nominee";
import { IJointLifeAddendum } from "./JointLifeAddendum/interfaces";
import { jointMedicalInitialValues as initialValuesJointLife } from "./JointLifeAddendum";
import { initialValues as initialValuesMedical } from "./ProposalDetails/MedicalAndLifeStyle";
import { MedicalDetailsInterface } from "src/redux/Reducers/medicalLifestyle/interface";
import { countryCall, pincodeCall, subOccupationCall } from "src/services/Master";
import regex from "../regex";
import { GENERAL_DETAILS_MAPPING, prePopulateST1Code } from "./resources";
import { getFullName } from "./ProposalDetails/resources";
import StorageService from "src/utils/Storage/storageService";
import { partners } from "src/config/constant";
import { fileInitialValue } from "./CreateDetails";

const mapExistingPolicyDetails = (existingLife: IExistingLifeCover[]) => {
  const arr: IExistingLifeCover[] = [];
  existingLife?.forEach((data) => {
    const existingPObj = {
      acceptanceTerms: data?.acceptanceTerms || "",
      acceptanceTermsCode: data?.acceptanceTermsCode || "",
      nameOfInsuranceCompany: data?.nameOfInsuranceCompany || "",
      nameOfInsuranceCompanyCode: data?.nameOfInsuranceCompanyCode || "",
      policyNumber: data?.policyNumber || "",
      totalSumInsured: data?.totalSumInsured || ""
    };
    arr.push(existingPObj);
  });
  return arr;
};

export const mapNomineeDetails = (nominee: any[], masterData: any) => {
  const arr: NomineeFields[] = [];
  const relationshipMasterData = masterData?.relationshipDetails;
  const genderMasterData = masterData?.genderDetails;
  const salutationMasterData = masterData?.salutationDetails;
  nominee?.forEach((data) => {
    const nomineeObj: NomineeFields = {
      fullName: data?.fullName || "",
      email: data?.email || "",
      gender: genderMasterData[data?.gender || "M"],
      bankName: data?.bankName || "",
      bankAccountNumber: data?.bankAccountNumber || "",
      ifscCode: data?.ifscCode || "",
      permanentAddress: data?.permanentAddress || "",
      permanentPincode: data?.permanentPincode || "",
      appointeeMobileNo: data?.appointeeMobileNo || "",
      captureAppointeeBankDetails: data?.appointeeBankName ? true : false,
      captureAppointeeAddress: Boolean(data?.appointeeAddress) || false,
      appointeeRelationCode: data?.appointeeRelationship || "",
      captureBankDetails: Boolean(data?.bankName) || false,
      captureAddress: Boolean(data?.address) || false,
      genderCode: data?.gender || "M",
      appointeeBankAccountNumber: data?.appointeeBankAccountNumber || "",
      appointeeIfscCode: data?.appointeeIfscCode || "",
      appointeeBankName: data?.appointeeBankName || "",
      mobileNo: data?.mobileNo || "",
      appointeeEmail: data?.appointeeEmail || "",
      appointeePermanentAddress: data?.appointeePermanentAddress || "",
      appointeePermanentPincode: data?.appointeePermanentPincode || "",
      appointeeAddress: data?.appointeeAddress || "",
      appointeePincode: data?.appointeePincode || "",
      appointeeGender: genderMasterData[data?.appointeeGender || "M"],
      appointeeGenderCode: data?.appointeeGender || "M",
      appointeeName: data?.appointeeName || "",
      relationship:
        relationshipMasterData[data.gender ?? "M"].find(
          (d: { value: any }) => d.value == data.relationshipWithPrimary
        )?.label || "",
      dob: (data?.dob && moment(data?.dob).format("DD/MM/YYYY")) || "",
      appointeeDob: (data?.appointeeDob && moment(data?.appointeeDob).format("DD/MM/YYYY")) || "",
      appointeeRelation:
        relationshipMasterData[data?.appointeeGender ?? "M"].find(
          (d: { value: any }) => d.value == data.appointeeRelationship
        )?.label || "",
      share: data?.sharePercentage || "",
      isMinor: data?.isMinor || false,
      id: data?.id,
      relationshipCode: data?.relationshipCode || "",
      address: data?.address || "",
      isAddressSame: data?.isAddressSameAsProposer ?? false,
      isAppointeeAddressSameAsProposer: data?.isAppointeeAddressSameAsProposer ?? false,
      pincode: data?.pincode || "",
      title:
        salutationMasterData[data.gender ?? "M"].find((d: { value: any }) => d.value == data.title)
          ?.label || "",
      titleCode: data?.title || (data?.gender === "M" ? "MR" : "MS"),

      appointeeTitle:
        salutationMasterData[data.appointeeGender ?? "M"].find(
          (d: { value: any }) => d.value == data.appointeeTitle
        )?.label || "",
      appointeeTitleCode: data?.appointeeTitle || (data?.appointeeGender === "M" ? "MR" : "MS")
    };
    nomineeObj.genderCode = data?.gender || "M";
    nomineeObj.relationshipCode = data?.relationshipWithPrimary || "";
    nomineeObj.appointeeRelationCode = data?.appointeeRelationship || "";
    nomineeObj.appointeeGenderCode = data?.appointeeGender || "M";
    arr.push(nomineeObj);
  });
  return arr;
};
//new fields
const familyMedicalHistory = (familyMedicalHistory: any[]) => {
  const arr: familyMedicalData[] = [];
  familyMedicalHistory?.forEach((data) => {
    const medicalObj: familyMedicalData = {
      familyPersonName: data.familyPersonName || "",
      familyRelation: data.familyRelation || "",
      status: data.status || "",
      sufferingAge: data.sufferingAge || "",
      ageOfDeath: data.ageOfDeath || "",
      presentStateOfHealth: data.presentStateOfHealth || "",
      causeDeath: data.causeDeath || ""
    };
    arr.push(medicalObj);
  });
  // console.log("arr", familyMedicalHistory, arr);
  return arr;
};

const mapMemberDetail = (persistData: any, leadData: any) => {
  return persistData === leadData ? undefined : !persistData ? null : persistData;
};

const bindProposerAPIData = async (
  persistData: ProposerDetails,
  responseData: any,
  masterData: any = {}
) => {
  const proposerData = responseData?.Members?.filter((ele: any) => ele.isJointMember === false)[0];
  const memberId = responseData?.Members?.filter((ele: any) => ele.isJointMember === false)[0]?.id;
  // if user fills the form and goes back to dashboard and clicks on another application, then data should be populated according to new application
  const newPersistData = responseData?.id === persistData.applicationId ? persistData : {};
  const genderMasterData = masterData?.genderDetails;
  const educationMasterData = masterData?.educationDetails;
  const maritalStatusMasterData = masterData?.maritalstatusDetails;
  const occupationMasterData = masterData?.occupationDetails;
  const salutationMasterData = masterData?.salutationDetails;
  const obj: ProposerDetails = {
    ...newPersistData,
    general: {
      title:
        salutationMasterData[proposerData?.gender].find(
          (d: { value: any }) => d.value == proposerData?.title
        )?.label || "",
      titleCode: proposerData?.title || (proposerData?.gender === "M" ? "MR" : "MS"),
      otherTitle: "",
      gender: genderMasterData[proposerData?.gender || "M"] || "",
      genderCode: proposerData?.gender || "M",
      firstName: proposerData?.firstName || "",
      middleName: proposerData?.middleName || "",
      lastName: proposerData?.lastName || "",
      dob: (proposerData?.dob && moment(proposerData?.dob).format("DD/MM/YYYY")) || "",
      maritalStatus: maritalStatusMasterData[proposerData?.maritalStatus || ""] || "",
      maritalStatusCode: proposerData?.maritalStatus || "",
      nationality:
        NaionalityOptions.nationality[proposerData?.nationality] ||
        NaionalityOptions.nationality[""],
      nationalityCode: proposerData?.nationality || "",
      countryOfResidence: "",
      countryOfResidenceCode: proposerData?.countryOfResidence || "",
      cityOfResidence: proposerData?.cityOfResidence || "",
      dateOfLastEntry:
        (proposerData?.lastEntryToIndiaDate &&
          moment(proposerData?.lastEntryToIndiaDate).format("DD/MM/YYYY")) ||
        "",
      educationQualification:
        (proposerData?.educationQualification &&
          educationMasterData[proposerData?.educationQualification]) ||
        "",
      educationQualificationCode: proposerData?.educationQualification || "",
      mobileNo: proposerData?.mobileNo || "",
      email: proposerData?.email || "",
      occupation: occupationMasterData[proposerData?.occupation || ""] || "",
      occupationCode: proposerData?.occupation || "",
      subOccupation: "",
      subOccupationCode: proposerData?.subOccupation || "",
      nameOfOrganization: proposerData?.organisationName || "",
      designation: proposerData?.designation || "",
      annualIncome: proposerData?.annualIncome || "",
      panNo: proposerData?.panNo || "",
      natureOfWork: proposerData?.natureOfWork || "",
      relationship: "Self",
      isJointJourney: false,
      telePhoneNo: proposerData?.telePhoneNo || "",
      requirementFlag: !!proposerData?.requirementFlag,
      isProportionateLife: false,
      UIDNo: proposerData?.UIDNo || "",
      electronicAccount:
        (proposerData?.electronicAccount &&
          (proposerData?.electronicAccount === "yes" ? "Yes" : "No")) ||
        "",
      eiaNumber: proposerData?.eiaNumber || "",
      businessOwner: proposerData?.businessOwner || false,
      housewifeFlag: proposerData?.housewifeFlag || false
    },
    address: {
      address: {
        address1: proposerData?.addressLine1 || "",
        address2: proposerData?.addressLine2 || "",
        address3: proposerData?.addressLine3 || "",
        pinCode: proposerData?.pincode || "",
        city: "",
        cityCode: proposerData?.city || "",
        state: "",
        stateCode: proposerData?.state || ""
      }
    },
    nominee: {
      nominee: proposerData?.Nominees?.length
        ? mapNomineeDetails(proposerData?.Nominees, masterData)
        : [nomineeIndividualField]
    }
  };
  const { pincode, countryOfResidence, subOccupation } = proposerData || {};
  if (pincode) {
    const pincodeResponse = await pincodeCall(pincode);
    obj.address!.address.state = pincodeResponse?.data?.state;
    obj.address!.address.stateCode = pincodeResponse?.data?.stateCode;
    obj.address!.address.city = pincodeResponse?.data?.city;
    obj.address!.address.cityCode = pincodeResponse?.data?.cityCode;
  }
  if (countryOfResidence) {
    const countryResponse = await countryCall({ code: countryOfResidence });
    obj.general!.countryOfResidence = countryResponse?.data[0]?.name;
    obj.general!.countryOfResidenceCode = countryResponse?.data[0]?.code;
  }
  if (subOccupation) {
    const subOccupationResponse = await subOccupationCall({ code: subOccupation });
    obj.general!.subOccupation = subOccupationResponse?.data[0]?.name;
    obj.general!.subOccupationCode = subOccupationResponse?.data[0]?.code;
  }
  return { obj, memberId };
};

const bindJointLifeAPIData = async (
  persistData: JointLifeDetails,
  responseData: any,
  masterData: any = {}
) => {
  const jointMemberData = responseData?.Members?.filter(
    (ele: any) => ele.isJointMember === true
  )[0];
  const memberId = responseData?.Members?.filter((ele: any) => ele.isJointMember === true)[0]?.id;
  // if user fills the form and goes back to dashboard and clicks on another application, then data should be populated according to the new application
  // const newPersistData =
  //   responseData?.id === persistData.applicationId ? persistData : ({} as JointLifeDetails);
  // const jointLifePersistDetails = newPersistData?.jointLifeDetails || {};
  const existingPolicyDetials = responseData?.Members.filter(
    (val: any): any => val.isJointMember === true
  )[0];
  // const addressData = jointLifePersistDetails?.address;
  const genderMasterData = masterData?.genderDetails;
  const educationMasterData = masterData?.educationDetails;
  const maritalStatusMasterData = masterData?.maritalstatusDetails;
  const occupationMasterData = masterData?.occupationDetails;
  const relationshipMasterData = masterData?.jointRelationshipDetails;
  const salutationMasterData = masterData?.salutationDetails;
  const obj = {
    member: {
      relationship:
        relationshipMasterData[jointMemberData?.gender ?? "M"].find(
          (d: { value: any }) => d.value == jointMemberData?.relationshipWithProposer
        )?.label || "",
      relationshipCode: jointMemberData?.relationshipWithProposer || "",
      title:
        salutationMasterData[jointMemberData?.gender ?? "M"].find(
          (d: { value: any }) => d.value == jointMemberData?.title
        )?.label || "",

      titleCode:
        jointMemberData?.title || (["M", "T"].includes(jointMemberData?.gender) ? "MR" : "MS"),
      otherTitle: "",
      gender: genderMasterData[jointMemberData?.gender || "M"] || "",
      genderCode: jointMemberData?.gender || "M",
      firstName: jointMemberData?.firstName || "",
      middleName: jointMemberData?.middleName || "",
      lastName: jointMemberData?.lastName || "",
      dob: (jointMemberData?.dob && moment(jointMemberData?.dob).format("DD/MM/YYYY")) || "",
      maritalStatus: maritalStatusMasterData[jointMemberData?.maritalStatus || ""] || "",
      maritalStatusCode: jointMemberData?.maritalStatus || "",
      nationality:
        NaionalityOptions.nationality[jointMemberData?.nationality] ||
        NaionalityOptions.nationality[""],
      nationalityCode: jointMemberData?.nationality || "",
      countryOfResidence: "",
      countryOfResidenceCode: jointMemberData?.countryOfResidence || "",
      cityOfResidence: jointMemberData?.cityOfResidence || "",
      dateOfLastEntry:
        (jointMemberData?.lastEntryToIndiaDate &&
          moment(jointMemberData?.lastEntryToIndiaDate).format("DD/MM/YYYY")) ||
        "",
      educationQualification: educationMasterData[jointMemberData?.educationQualification] || "",
      educationQualificationCode: jointMemberData?.educationQualification || "",
      mobileNo: jointMemberData?.mobileNo || "",
      email: jointMemberData?.email || "",
      occupation: occupationMasterData[jointMemberData?.occupation] || "",
      occupationCode: jointMemberData?.occupation || "",
      subOccupation: "",
      subOccupationCode: jointMemberData?.subOccupation || "",
      nameOfOrganization: jointMemberData?.organisationName || "",
      designation: jointMemberData?.designation || "",
      annualIncome: jointMemberData?.annualIncome || "",
      panNo: jointMemberData?.panNo || "",
      natureOfWork: jointMemberData?.natureOfWork || "",
      telePhoneNo: jointMemberData?.telePhoneNo || "",
      UIDNo: jointMemberData?.UIDNo || "",
      electronicAccount:
        (jointMemberData?.electronicAccount &&
          (jointMemberData?.electronicAccount === "yes" ? "Yes" : "No")) ||
        "",
      eiaNumber: jointMemberData?.eiaNumber || "",
      businessOwner: jointMemberData?.businessOwner || false
    },
    address: {
      address1: jointMemberData?.addressLine1 || "",
      address2: jointMemberData?.addressLine2 || "",
      address3: jointMemberData?.addressLine3 || "",
      pinCode: jointMemberData?.pincode || "",
      cityCode: jointMemberData?.city,
      city: "",
      stateCode: jointMemberData?.state,
      state: ""
    },
    existingPolicy: {
      existingLifeCover: existingPolicyDetials?.premiumDetails?.existingLifeCover || false,
      existingPolicyDetails: mapExistingPolicyDetails(
        existingPolicyDetials?.premiumDetails?.existingPolicyDetails || [
          existingLifeCoverInitialValuesObject
        ]
      )
    },
    isAddressProposer: jointMemberData?.isAddressSameAsProposer ?? false,
    jointCoBorrowerFlag: responseData?.jointCoBorrowerFlag ?? false,
    jointGuarantorFlag: responseData?.jointGuarantorFlag ?? false,
    jointPrimaryBorrowerFlag: responseData?.jointPrimaryBorrowerFlag ?? false,
    jointHousewifeFlag: responseData?.jointHousewifeFlag ?? false,
    requirementFlag: jointMemberData?.requirementFlag,
    businessOwner: jointMemberData?.businessOwner ?? false,
    medicalDetails: {
      declare:
        jointMemberData?.medicalAndLifeStyle?.declare ??
        initialValuesJointLife?.medicalDetails?.declare,
      medicalHealth:
        jointMemberData?.medicalAndLifeStyle?.medicalHealth ??
        initialValuesJointLife?.medicalDetails?.medicalHealth,
      weight:
        jointMemberData?.medicalAndLifeStyle?.weight ??
        initialValuesJointLife?.medicalDetails?.weight,
      height:
        jointMemberData?.medicalAndLifeStyle?.height ??
        initialValuesJointLife?.medicalDetails?.height,
      measurement:
        jointMemberData?.medicalAndLifeStyle?.measurement ||
        initialValuesJointLife?.medicalDetails?.measurement,
      familyBackground:
        jointMemberData?.medicalAndLifeStyle?.familyBackground ??
        initialValuesJointLife?.medicalDetails?.familyBackground,
      diabetes:
        jointMemberData?.medicalAndLifeStyle?.diabetes ??
        initialValuesJointLife?.medicalDetails?.diabetes,
      highBloodPressure:
        jointMemberData?.medicalAndLifeStyle?.highBloodPressure ??
        initialValuesJointLife?.medicalDetails?.highBloodPressure,
      stroke:
        jointMemberData?.medicalAndLifeStyle?.stroke ??
        initialValuesJointLife?.medicalDetails?.stroke,
      asthma:
        jointMemberData?.medicalAndLifeStyle?.asthma ??
        initialValuesJointLife?.medicalDetails?.asthma,
      epilepsy:
        jointMemberData?.medicalAndLifeStyle?.epilepsy ??
        initialValuesJointLife?.medicalDetails?.epilepsy,
      liverDisease:
        jointMemberData?.medicalAndLifeStyle?.liverDisease ??
        initialValuesJointLife?.medicalDetails?.liverDisease,
      kidneyDisease:
        jointMemberData?.medicalAndLifeStyle?.kidneyDisease ??
        initialValuesJointLife?.medicalDetails?.kidneyDisease,
      bloodDisorder:
        jointMemberData?.medicalAndLifeStyle?.bloodDisorder ??
        initialValuesJointLife?.medicalDetails?.bloodDisorder,
      tumor:
        jointMemberData?.medicalAndLifeStyle?.tumor ??
        initialValuesJointLife?.medicalDetails?.tumor,
      anxiety:
        jointMemberData?.medicalAndLifeStyle?.anxiety ??
        initialValuesJointLife?.medicalDetails?.anxiety,
      aids:
        jointMemberData?.medicalAndLifeStyle?.aids ?? initialValuesJointLife?.medicalDetails?.aids,
      smoker:
        jointMemberData?.medicalAndLifeStyle?.smoker ??
        initialValuesJointLife?.medicalDetails?.smoker,
      cigaratte:
        jointMemberData?.medicalAndLifeStyle?.cigaratte ??
        initialValuesJointLife?.medicalDetails?.cigaratte,
      bidi:
        jointMemberData?.medicalAndLifeStyle?.bidi ?? initialValuesJointLife?.medicalDetails?.bidi,
      cigar:
        jointMemberData?.medicalAndLifeStyle?.cigar ??
        initialValuesJointLife?.medicalDetails?.cigar,
      panMasalaAmount:
        jointMemberData?.medicalAndLifeStyle?.panMasalaAmount ??
        initialValuesJointLife?.medicalDetails?.panMasalaAmount,
      panMasala:
        jointMemberData?.medicalAndLifeStyle?.panMasala ??
        initialValuesJointLife?.medicalDetails?.panMasala,
      gutkha:
        jointMemberData?.medicalAndLifeStyle?.gutkha ??
        initialValuesJointLife?.medicalDetails?.gutkha,
      chewing:
        jointMemberData?.medicalAndLifeStyle?.chewing ??
        initialValuesJointLife?.medicalDetails?.chewing,
      cigaratteAmount:
        jointMemberData?.medicalAndLifeStyle?.cigaratteAmount ??
        initialValuesJointLife?.medicalDetails?.cigaratteAmount,
      cigarAmount:
        jointMemberData?.medicalAndLifeStyle?.cigarAmount ??
        initialValuesJointLife?.medicalDetails?.cigarAmount,
      bidiAmount:
        jointMemberData?.medicalAndLifeStyle?.bidiAmount ??
        initialValuesJointLife?.medicalDetails?.bidiAmount,
      gutkhaAmount:
        jointMemberData?.medicalAndLifeStyle?.gutkhaAmount ??
        initialValuesJointLife?.medicalDetails?.gutkhaAmount,
      chewingAmount:
        jointMemberData?.medicalAndLifeStyle?.chewingAmount ??
        initialValuesJointLife?.medicalDetails?.chewingAmount,
      alcohol:
        jointMemberData?.medicalAndLifeStyle?.alcohol ??
        initialValuesJointLife?.medicalDetails?.alcohol,
      drugs:
        jointMemberData?.medicalAndLifeStyle?.drugs ??
        initialValuesJointLife?.medicalDetails?.drugs,
      disability:
        jointMemberData?.medicalAndLifeStyle?.disability ??
        initialValuesJointLife?.medicalDetails?.disability,
      gyneComplications:
        jointMemberData?.medicalAndLifeStyle?.gyneComplications ??
        initialValuesJointLife?.medicalDetails?.gyneComplications,
      pregnant:
        jointMemberData?.medicalAndLifeStyle?.pregnant ??
        initialValuesJointLife?.medicalDetails?.pregnant,
      pregnancyDuration:
        jointMemberData?.medicalAndLifeStyle?.pregnancyDuration ??
        initialValuesJointLife?.medicalDetails?.pregnancyDuration,
      remarks:
        jointMemberData?.medicalAndLifeStyle?.remarks ??
        initialValuesJointLife?.medicalDetails?.remarks,
      beer:
        jointMemberData?.medicalAndLifeStyle?.beer ?? initialValuesJointLife?.medicalDetails?.beer,
      wine:
        jointMemberData?.medicalAndLifeStyle?.wine ?? initialValuesJointLife?.medicalDetails?.wine,
      liquor:
        jointMemberData?.medicalAndLifeStyle?.liquor ??
        initialValuesJointLife?.medicalDetails?.liquor,
      lessThanOnce:
        jointMemberData?.medicalAndLifeStyle?.lessThanOnce ??
        initialValuesJointLife?.medicalDetails?.lessThanOnce,
      moreThanOnce:
        jointMemberData?.medicalAndLifeStyle?.moreThanOnce ??
        initialValuesJointLife?.medicalDetails?.moreThanOnce,
      once:
        jointMemberData?.medicalAndLifeStyle?.once ?? initialValuesJointLife?.medicalDetails?.once,
      daily:
        jointMemberData?.medicalAndLifeStyle?.daily ??
        initialValuesJointLife?.medicalDetails?.daily,
      alcoholAmount:
        jointMemberData?.medicalAndLifeStyle?.alcoholAmount ??
        initialValuesJointLife?.medicalDetails?.alcoholAmount,
      familyHealthHistory:
        jointMemberData?.medicalAndLifeStyle?.familyHealthHistory ??
        responseData?.familyHealthHistory ??
        initialValuesJointLife?.medicalDetails?.familyHealthHistory,
      familyMedicalHistory: familyMedicalHistory(
        jointMemberData?.medicalAndLifeStyle?.familyMedicalHistory ??
          initialValuesJointLife?.medicalDetails?.familyMedicalHistory
      ),
      alcoholConsumptionSince:
        jointMemberData?.medicalAndLifeStyle?.alcoholConsumptionSince ??
        initialValuesJointLife.medicalDetails?.alcoholConsumptionSince,
      anaemia:
        jointMemberData?.medicalAndLifeStyle?.anaemia ??
        initialValuesJointLife.medicalDetails?.anaemia,
      anxietyDepression:
        jointMemberData?.medicalAndLifeStyle?.anxietyDepression ??
        initialValuesJointLife.medicalDetails?.anxietyDepression,
      arthritis:
        jointMemberData?.medicalAndLifeStyle?.arthritis ??
        initialValuesJointLife.medicalDetails?.arthritis,
      asthamaTuberculosis:
        jointMemberData?.medicalAndLifeStyle?.asthamaTuberculosis ??
        initialValuesJointLife.medicalDetails?.asthamaTuberculosis,
      bloodPressureHeartAttack:
        jointMemberData?.medicalAndLifeStyle?.bloodPressureHeartAttack ??
        initialValuesJointLife.medicalDetails?.bloodPressureHeartAttack,
      cancerTumor:
        jointMemberData?.medicalAndLifeStyle?.cancerTumor ??
        initialValuesJointLife.medicalDetails?.cancerTumor,
      diabetesAndSugar:
        jointMemberData?.medicalAndLifeStyle?.diabetesAndSugar ??
        initialValuesJointLife.medicalDetails?.diabetesAndSugar,

      existingApplication:
        jointMemberData?.medicalAndLifeStyle?.existingApplication ??
        initialValuesJointLife.medicalDetails?.existingApplication,

      familyHealth:
        jointMemberData?.medicalAndLifeStyle?.familyHealth ??
        initialValuesJointLife.medicalDetails?.familyHealth,

      hospitalisation:
        jointMemberData?.medicalAndLifeStyle?.hospitalisation ??
        initialValuesJointLife.medicalDetails?.hospitalisation,

      indigestion:
        jointMemberData?.medicalAndLifeStyle?.indigestion ??
        initialValuesJointLife.medicalDetails?.indigestion,

      kidneyStoneBloodUrine:
        jointMemberData?.medicalAndLifeStyle?.kidneyStoneBloodUrine ??
        initialValuesJointLife.medicalDetails?.kidneyStoneBloodUrine,

      majorDisorder:
        jointMemberData?.medicalAndLifeStyle?.majorDisorder ??
        initialValuesJointLife.medicalDetails?.majorDisorder,
      occupationEnquiry:
        jointMemberData?.medicalAndLifeStyle?.occupationEnquiry ??
        initialValuesJointLife.medicalDetails?.occupationEnquiry,
      otherDisease:
        jointMemberData?.medicalAndLifeStyle?.otherDisease ??
        initialValuesJointLife.medicalDetails?.otherDisease,
      otherDiseaseDetails:
        jointMemberData?.medicalAndLifeStyle?.otherDiseaseDetails ??
        initialValuesJointLife.medicalDetails?.otherDiseaseDetails,
      smokingConsumptionSince:
        jointMemberData?.medicalAndLifeStyle?.smokingConsumptionSince ??
        initialValuesJointLife.medicalDetails?.smokingConsumptionSince,
      strokeParalysis:
        jointMemberData?.medicalAndLifeStyle?.strokeParalysis ??
        initialValuesJointLife.medicalDetails?.strokeParalysis,

      thyroid:
        jointMemberData?.medicalAndLifeStyle?.thyroid ??
        initialValuesJointLife.medicalDetails?.thyroid,
      underTreatment:
        jointMemberData?.medicalAndLifeStyle?.underTreatment ??
        initialValuesJointLife.medicalDetails?.underTreatment,

      heartDisease:
        jointMemberData?.medicalAndLifeStyle?.heartDisease ??
        initialValuesJointLife.medicalDetails?.heartDisease,
      lungDisease:
        jointMemberData?.medicalAndLifeStyle?.lungDisease ??
        initialValuesJointLife.medicalDetails?.lungDisease,
      highCholesterol:
        jointMemberData?.medicalAndLifeStyle?.highCholesterol ??
        initialValuesJointLife.medicalDetails?.highCholesterol,
      hivAidsSTI:
        jointMemberData?.medicalAndLifeStyle?.hivAidsSTI ??
        initialValuesJointLife.medicalDetails?.hivAidsSTI,
      congenitalDefect:
        jointMemberData?.medicalAndLifeStyle?.congenitalDefect ??
        initialValuesJointLife.medicalDetails?.congenitalDefect,
      genitourinaryHearingVisionDisorder:
        jointMemberData?.medicalAndLifeStyle?.genitourinaryHearingVisionDisorder ??
        initialValuesJointLife.medicalDetails?.genitourinaryHearingVisionDisorder,
      paralysis:
        jointMemberData?.medicalAndLifeStyle?.paralysis ??
        initialValuesJointLife.medicalDetails?.paralysis,
      brainNervousSystemDisorder:
        jointMemberData?.medicalAndLifeStyle?.brainNervousSystemDisorder ??
        initialValuesJointLife.medicalDetails?.brainNervousSystemDisorder,
      thyroidDisorder:
        jointMemberData?.medicalAndLifeStyle?.thyroidDisorder ??
        initialValuesJointLife.medicalDetails?.thyroidDisorder,
      chronicDigestiveDisorder:
        jointMemberData?.medicalAndLifeStyle?.chronicDigestiveDisorder ??
        initialValuesJointLife.medicalDetails?.chronicDigestiveDisorder,
      endocrineDisorder:
        jointMemberData?.medicalAndLifeStyle?.endocrineDisorder ??
        initialValuesJointLife.medicalDetails?.endocrineDisorder,
      anyOtherDisease:
        jointMemberData?.medicalAndLifeStyle?.anyOtherDisease ??
        initialValuesJointLife.medicalDetails?.anyOtherDisease ??
        "",
      weightLossProgram:
        jointMemberData?.medicalAndLifeStyle?.weightLossProgram ??
        initialValuesJointLife.medicalDetails?.weightLossProgram,
      investigateCheckups:
        jointMemberData?.medicalAndLifeStyle?.investigateCheckups ??
        initialValuesJointLife.medicalDetails?.investigateCheckups,
      personalConsumptionSmoking:
        jointMemberData?.medicalAndLifeStyle?.personalConsumptionSmoking ??
        initialValuesJointLife.medicalDetails?.personalConsumptionSmoking,
      personalConsumptionTobacco:
        jointMemberData?.medicalAndLifeStyle?.personalConsumptionTobacco ??
        initialValuesJointLife.medicalDetails?.personalConsumptionTobacco,
      personalConsumptionAlcohol:
        jointMemberData?.medicalAndLifeStyle?.personalConsumptionAlcohol ??
        initialValuesJointLife.medicalDetails?.personalConsumptionAlcohol,
      isOccupationHazardious:
        jointMemberData?.medicalAndLifeStyle?.isOccupationHazardious ??
        initialValuesJointLife.medicalDetails?.isOccupationHazardious,
      mines:
        jointMemberData?.medicalAndLifeStyle?.mines ?? initialValuesJointLife.medicalDetails?.mines,
      explosives:
        jointMemberData?.medicalAndLifeStyle?.explosives ??
        initialValuesJointLife.medicalDetails?.explosives,
      radiation:
        jointMemberData?.medicalAndLifeStyle?.radiation ??
        initialValuesJointLife.medicalDetails?.radiation,
      corrosiveChemicals:
        jointMemberData?.medicalAndLifeStyle?.corrosiveChemicals ??
        initialValuesJointLife.medicalDetails?.corrosiveChemicals,
      hobbyQuery:
        jointMemberData?.medicalAndLifeStyle?.hobbyQuery ??
        initialValuesJointLife.medicalDetails?.hobbyQuery,
      aviation:
        jointMemberData?.medicalAndLifeStyle?.aviation ??
        initialValuesJointLife.medicalDetails?.aviation,
      diving:
        jointMemberData?.medicalAndLifeStyle?.diving ??
        initialValuesJointLife.medicalDetails?.diving,
      mountaineering:
        jointMemberData?.medicalAndLifeStyle?.mountaineering ??
        initialValuesJointLife.medicalDetails?.mountaineering,
      seaDiving:
        jointMemberData?.medicalAndLifeStyle?.seaDiving ??
        initialValuesJointLife.medicalDetails?.seaDiving,
      motorRacing:
        jointMemberData?.medicalAndLifeStyle?.motorRacing ??
        initialValuesJointLife.medicalDetails?.motorRacing,
      bungeeJumping:
        jointMemberData?.medicalAndLifeStyle?.bungeeJumping ??
        initialValuesJointLife.medicalDetails?.bungeeJumping,
      familyHealthQuery:
        jointMemberData?.medicalAndLifeStyle?.familyHealthQuery ??
        initialValuesJointLife.medicalDetails?.familyHealthQuery,
      femaleOrientedQuery:
        jointMemberData?.medicalAndLifeStyle?.femaleOrientedQuery ??
        initialValuesJointLife.medicalDetails?.femaleOrientedQuery
    },
    covidAndNriDetails: {
      covidTest: {
        covidPositive: jointMemberData?.covidDetails?.covidTest?.covidPositive ?? false,
        covidQuarantine: jointMemberData?.covidDetails?.covidTest?.covidQuarantine || "",
        covidComplication: jointMemberData?.covidDetails?.covidTest?.covidComplication || ""
      },
      covidVaccineDates: {
        covidVaccinated: jointMemberData?.covidDetails?.covidVaccineDates?.covidVaccinated ?? true,
        dateOfFirstDose: jointMemberData?.covidDetails?.covidVaccineDates?.dateOfFirstDose || "",
        dateOfSecondDose: jointMemberData?.covidDetails?.covidVaccineDates?.dateOfSecondDose || "",
        dateOfBoosterDose: jointMemberData?.covidDetails?.covidVaccineDates?.dateOfBoosterDose || ""
      },
      nriDetails: {
        currentCountry: jointMemberData?.NRIDetails?.nriDetails?.currentCountry || "",
        currentCountryCode: jointMemberData?.NRIDetails?.nriDetails?.currentCountryCode || "",
        cityOfResidence: jointMemberData?.NRIDetails?.nriDetails?.cityOfResidence || "",
        lastDateOfEntryToIn: jointMemberData?.NRIDetails?.nriDetails?.lastDateOfEntryToIn || "",
        exitDateFromIndia: jointMemberData?.NRIDetails?.nriDetails?.exitDateFromIndia || "",
        durationOfStayAbroad: jointMemberData?.NRIDetails?.nriDetails?.durationOfStayAbroad || "",
        purposeOfStayAbroad: jointMemberData?.NRIDetails?.nriDetails?.purposeOfStayAbroad || "",
        insurancePurpose:
          jointMemberData?.nriDetails?.insurancePurpose ||
          jointMemberData?.NRIDetails?.nriDetails?.insurancePurpose ||
          ""
      },
      otherCountryTravel: {
        isOtherCountryTravel:
          jointMemberData?.NRIDetails?.otherCountryTravel?.isOtherCountryTravel ?? false,
        countryName: jointMemberData?.NRIDetails?.otherCountryTravel?.countryName || "",
        countryNameCode: jointMemberData?.NRIDetails?.otherCountryTravel?.countryNameCode || "",
        duration: jointMemberData?.NRIDetails?.otherCountryTravel?.duration || "",
        purpose: jointMemberData?.NRIDetails?.otherCountryTravel?.purpose || ""
      },
      occupationDetails: {
        occupationNameAndRole:
          jointMemberData?.NRIDetails?.occupationDetails?.occupationNameAndRole || ""
      },
      salaried: {
        isOtherPolicyOutsideIndia:
          jointMemberData?.NRIDetails?.policyDetails?.isOtherPolicyOutsideIndia ?? false,
        isSalaried: jointMemberData?.NRIDetails?.salaried?.isSalaried ?? false,
        companyName: jointMemberData?.NRIDetails?.salaried?.companyName || "",
        designation: jointMemberData?.NRIDetails?.salaried?.designation || "",
        currency: jointMemberData?.NRIDetails?.salaried?.currency || "Rupee",
        monthlyIncome: jointMemberData?.NRIDetails?.salaried?.monthlyIncome || ""
      },
      selfEmployed: {
        isSelfEmployed: jointMemberData?.NRIDetails?.selfEmployed?.isSelfEmployed ?? false,
        grossTurnover: jointMemberData?.NRIDetails?.selfEmployed?.grossTurnover || "",
        annualIncome: jointMemberData?.NRIDetails?.selfEmployed?.annualIncome || ""
      },
      bankDetails: {
        nameOfTheBank: jointMemberData?.NRIDetails?.bankDetails?.nameOfTheBank || "",
        branch: jointMemberData?.NRIDetails?.bankDetails?.branch || "",
        accountNumber: jointMemberData?.NRIDetails?.bankDetails?.accountNumber || ""
      },
      residence: {
        nameOfTheBankResidence: jointMemberData?.NRIDetails?.residence?.nameOfTheBankResidence || ""
      },
      policyDetails: {
        isOtherPolicyOutsideIndia:
          jointMemberData?.NRIDetails?.policyDetails?.isOtherPolicyOutsideIndia ?? false,
        insurerName: jointMemberData?.NRIDetails?.policyDetails?.insurerName || "",
        sumAssured: jointMemberData?.NRIDetails?.policyDetails?.sumAssured || "",
        premiumAccount: jointMemberData?.NRIDetails?.policyDetails?.premiumAccount || "",
        policyStatus: jointMemberData?.NRIDetails?.policyDetails?.policyStatus || "",
        dateOfInsurance: jointMemberData?.NRIDetails?.policyDetails?.dateOfInsurance || ""
      }
    },
    medicalDetailsV2: jointMemberData?.medicalAndLifeStyle || null
  };
  const { pincode, countryOfResidence, subOccupation } = jointMemberData || {};
  if (pincode) {
    const pincodeResponse = await pincodeCall(pincode);
    obj.address!.state = pincodeResponse?.data?.state;
    obj.address!.city = pincodeResponse?.data?.city;
  }
  if (countryOfResidence) {
    const countryResponse = await countryCall({ code: countryOfResidence });
    obj.member!.countryOfResidence = countryResponse?.data[0]?.name;
  }
  if (subOccupation) {
    const subOccupationResponse = await subOccupationCall({ code: subOccupation });
    obj.member!.subOccupation = subOccupationResponse?.data[0]?.name;
  }
  return { obj, memberId };
};

const bindMedicalLifestyleAPIData = (persistData: MedicalDetailsInterface, responseData: any) => {
  const primaryMember = responseData.Members.filter(
    (ele: { isJointMember: boolean }) => ele.isJointMember === false
  );
  let primaryMemberMedicalAndLifeStyle: any = [];
  if (primaryMember.length > 0) {
    primaryMemberMedicalAndLifeStyle = primaryMember[0].medicalAndLifeStyle;
  }
  const newPersistData =
    responseData?.id === persistData.applicationId ? persistData : ({} as MedicalDetailsInterface);
  console.log(
    "newPersistData",
    newPersistData,
    primaryMemberMedicalAndLifeStyle,
    initialValuesMedical
  );
  // console.log();
  const obj: MedicalDetailsInterface = {
    medicalDetails: {
      declare:
        primaryMemberMedicalAndLifeStyle?.declare ?? initialValuesMedical.medicalDetails?.declare,
      medicalHealth:
        primaryMemberMedicalAndLifeStyle?.medicalHealth ??
        initialValuesMedical?.medicalDetails?.medicalHealth,
      weight:
        primaryMemberMedicalAndLifeStyle?.weight ?? initialValuesMedical?.medicalDetails?.weight,
      height:
        primaryMemberMedicalAndLifeStyle?.height ?? initialValuesMedical?.medicalDetails?.height,

      measurement:
        primaryMemberMedicalAndLifeStyle?.measurement ||
        initialValuesMedical?.medicalDetails?.measurement,
      familyBackground:
        primaryMemberMedicalAndLifeStyle?.familyBackground ??
        initialValuesMedical?.medicalDetails?.familyBackground,
      diabetes:
        primaryMemberMedicalAndLifeStyle?.diabetes ??
        initialValuesMedical?.medicalDetails?.diabetes,
      highBloodPressure:
        primaryMemberMedicalAndLifeStyle?.highBloodPressure ??
        initialValuesMedical?.medicalDetails?.highBloodPressure,
      stroke:
        primaryMemberMedicalAndLifeStyle?.stroke ?? initialValuesMedical?.medicalDetails?.stroke,
      asthma:
        primaryMemberMedicalAndLifeStyle?.asthma ?? initialValuesMedical?.medicalDetails?.asthma,
      epilepsy:
        primaryMemberMedicalAndLifeStyle?.epilepsy ??
        initialValuesMedical?.medicalDetails?.epilepsy,
      liverDisease:
        primaryMemberMedicalAndLifeStyle?.liverDisease ??
        initialValuesMedical?.medicalDetails?.liverDisease,
      kidneyDisease:
        primaryMemberMedicalAndLifeStyle?.kidneyDisease ??
        initialValuesMedical?.medicalDetails?.kidneyDisease,
      bloodDisorder:
        primaryMemberMedicalAndLifeStyle?.bloodDisorder ??
        initialValuesMedical?.medicalDetails?.bloodDisorder,
      tumor: primaryMemberMedicalAndLifeStyle?.tumor ?? initialValuesMedical?.medicalDetails?.tumor,
      anxiety:
        primaryMemberMedicalAndLifeStyle?.anxiety ?? initialValuesMedical?.medicalDetails?.anxiety,
      aids: primaryMemberMedicalAndLifeStyle?.aids ?? initialValuesMedical?.medicalDetails?.aids,
      smoker:
        primaryMemberMedicalAndLifeStyle?.smoker ?? initialValuesMedical?.medicalDetails?.smoker,
      cigaratte:
        primaryMemberMedicalAndLifeStyle?.cigaratte ??
        initialValuesMedical?.medicalDetails?.cigaratte,
      bidi: primaryMemberMedicalAndLifeStyle?.bidi ?? initialValuesMedical?.medicalDetails?.bidi,
      cigar: primaryMemberMedicalAndLifeStyle?.cigar ?? initialValuesMedical?.medicalDetails?.cigar,
      panMasalaAmount:
        primaryMemberMedicalAndLifeStyle?.panMasalaAmount ??
        initialValuesMedical?.medicalDetails?.panMasalaAmount,
      panMasala:
        primaryMemberMedicalAndLifeStyle?.panMasala ??
        initialValuesMedical?.medicalDetails?.panMasala,
      gutkha:
        primaryMemberMedicalAndLifeStyle?.gutkha ?? initialValuesMedical?.medicalDetails?.gutkha,
      chewing:
        primaryMemberMedicalAndLifeStyle?.chewing ?? initialValuesMedical?.medicalDetails?.chewing,
      cigaratteAmount:
        primaryMemberMedicalAndLifeStyle?.cigaratteAmount ??
        initialValuesMedical?.medicalDetails?.cigaratteAmount,
      cigarAmount:
        primaryMemberMedicalAndLifeStyle?.cigarAmount ??
        initialValuesMedical?.medicalDetails?.cigarAmount,
      bidiAmount:
        primaryMemberMedicalAndLifeStyle?.bidiAmount ??
        initialValuesMedical?.medicalDetails?.bidiAmount,
      gutkhaAmount:
        primaryMemberMedicalAndLifeStyle?.gutkhaAmount ??
        initialValuesMedical?.medicalDetails?.gutkhaAmount,
      chewingAmount:
        primaryMemberMedicalAndLifeStyle?.chewingAmount ??
        initialValuesMedical?.medicalDetails?.chewingAmount,
      alcohol:
        primaryMemberMedicalAndLifeStyle?.alcohol ?? initialValuesMedical?.medicalDetails?.alcohol,
      drugs: primaryMemberMedicalAndLifeStyle?.drugs ?? initialValuesMedical?.medicalDetails?.drugs,
      disability:
        primaryMemberMedicalAndLifeStyle?.disability ??
        initialValuesMedical?.medicalDetails?.disability,
      gyneComplications:
        primaryMemberMedicalAndLifeStyle?.gyneComplications ??
        initialValuesMedical?.medicalDetails?.gyneComplications,
      pregnant:
        primaryMemberMedicalAndLifeStyle?.pregnant ??
        initialValuesMedical?.medicalDetails?.pregnant,
      pregnancyDuration:
        primaryMemberMedicalAndLifeStyle?.pregnancyDuration ??
        initialValuesMedical?.medicalDetails?.pregnancyDuration,
      remarks:
        primaryMemberMedicalAndLifeStyle?.remarks ?? initialValuesMedical?.medicalDetails?.remarks,
      beer: primaryMemberMedicalAndLifeStyle?.beer ?? initialValuesMedical?.medicalDetails?.beer,

      wine: primaryMemberMedicalAndLifeStyle?.wine ?? initialValuesMedical?.medicalDetails?.wine,

      liquor:
        primaryMemberMedicalAndLifeStyle?.liquor ?? initialValuesMedical?.medicalDetails?.liquor,

      lessThanOnce:
        primaryMemberMedicalAndLifeStyle?.lessThanOnce ??
        initialValuesMedical?.medicalDetails?.lessThanOnce,

      moreThanOnce:
        primaryMemberMedicalAndLifeStyle?.moreThanOnce ??
        initialValuesMedical?.medicalDetails?.moreThanOnce,
      once: primaryMemberMedicalAndLifeStyle?.once ?? initialValuesMedical?.medicalDetails?.once,

      daily: primaryMemberMedicalAndLifeStyle?.daily ?? initialValuesMedical?.medicalDetails?.daily,

      alcoholAmount:
        primaryMemberMedicalAndLifeStyle?.alcoholAmount ??
        initialValuesMedical?.medicalDetails?.alcoholAmount,
      familyHealthHistory:
        primaryMemberMedicalAndLifeStyle?.familyHealthHistory ??
        initialValuesMedical?.medicalDetails?.familyHealthHistory,
      familyMedicalHistory: familyMedicalHistory(
        primaryMemberMedicalAndLifeStyle?.familyMedicalHistory?.length > 0
          ? primaryMemberMedicalAndLifeStyle?.familyMedicalHistory
          : initialValuesMedical?.medicalDetails?.familyMedicalHistory
      ),
      alcoholConsumptionSince:
        primaryMemberMedicalAndLifeStyle?.alcoholConsumptionSince ??
        initialValuesMedical.medicalDetails?.alcoholConsumptionSince,
      anaemia:
        primaryMemberMedicalAndLifeStyle?.anaemia ?? initialValuesMedical.medicalDetails?.anaemia,
      anxietyDepression:
        primaryMemberMedicalAndLifeStyle?.anxietyDepression ??
        initialValuesMedical.medicalDetails?.anxietyDepression,
      arthritis:
        primaryMemberMedicalAndLifeStyle?.arthritis ??
        initialValuesMedical.medicalDetails?.arthritis,
      asthamaTuberculosis:
        primaryMemberMedicalAndLifeStyle?.asthamaTuberculosis ??
        initialValuesMedical.medicalDetails?.asthamaTuberculosis,
      bloodPressureHeartAttack:
        primaryMemberMedicalAndLifeStyle?.bloodPressureHeartAttack ??
        initialValuesMedical.medicalDetails?.bloodPressureHeartAttack,
      cancerTumor:
        primaryMemberMedicalAndLifeStyle?.cancerTumor ??
        initialValuesMedical.medicalDetails?.cancerTumor,
      diabetesAndSugar:
        primaryMemberMedicalAndLifeStyle?.diabetesAndSugar ??
        initialValuesMedical.medicalDetails?.diabetesAndSugar,

      existingApplication:
        primaryMemberMedicalAndLifeStyle?.existingApplication ??
        initialValuesMedical.medicalDetails?.existingApplication,

      familyHealth:
        primaryMemberMedicalAndLifeStyle?.familyHealth ??
        initialValuesMedical.medicalDetails?.familyHealth,

      hospitalisation:
        primaryMemberMedicalAndLifeStyle?.hospitalisation ??
        initialValuesMedical.medicalDetails?.hospitalisation,

      indigestion:
        primaryMemberMedicalAndLifeStyle?.indigestion ??
        initialValuesMedical.medicalDetails?.indigestion,

      kidneyStoneBloodUrine:
        primaryMemberMedicalAndLifeStyle?.kidneyStoneBloodUrine ??
        initialValuesMedical.medicalDetails?.kidneyStoneBloodUrine,

      majorDisorder:
        primaryMemberMedicalAndLifeStyle?.majorDisorder ??
        initialValuesMedical.medicalDetails?.majorDisorder,
      occupationEnquiry:
        primaryMemberMedicalAndLifeStyle?.occupationEnquiry ??
        initialValuesMedical.medicalDetails?.occupationEnquiry,
      otherDisease:
        primaryMemberMedicalAndLifeStyle?.otherDisease ??
        initialValuesMedical.medicalDetails?.otherDisease,
      otherDiseaseDetails:
        primaryMemberMedicalAndLifeStyle?.otherDiseaseDetails ??
        initialValuesMedical.medicalDetails?.otherDiseaseDetails,
      smokingConsumptionSince:
        primaryMemberMedicalAndLifeStyle?.smokingConsumptionSince ??
        initialValuesMedical.medicalDetails?.smokingConsumptionSince,
      strokeParalysis:
        primaryMemberMedicalAndLifeStyle?.strokeParalysis ??
        initialValuesMedical.medicalDetails?.strokeParalysis,
      thyroid:
        primaryMemberMedicalAndLifeStyle?.thyroid ?? initialValuesMedical.medicalDetails?.thyroid,
      underTreatment:
        primaryMemberMedicalAndLifeStyle?.underTreatment ??
        initialValuesMedical.medicalDetails?.underTreatment,

      heartDisease:
        primaryMemberMedicalAndLifeStyle?.heartDisease ??
        initialValuesMedical.medicalDetails?.heartDisease,
      lungDisease:
        primaryMemberMedicalAndLifeStyle?.lungDisease ??
        initialValuesMedical.medicalDetails?.lungDisease,
      highCholesterol:
        primaryMemberMedicalAndLifeStyle?.highCholesterol ??
        initialValuesMedical.medicalDetails?.highCholesterol,
      hivAidsSTI:
        primaryMemberMedicalAndLifeStyle?.hivAidsSTI ??
        initialValuesMedical.medicalDetails?.hivAidsSTI,
      congenitalDefect:
        primaryMemberMedicalAndLifeStyle?.congenitalDefect ??
        initialValuesMedical.medicalDetails?.congenitalDefect,
      genitourinaryHearingVisionDisorder:
        primaryMemberMedicalAndLifeStyle?.genitourinaryHearingVisionDisorder ??
        initialValuesMedical.medicalDetails?.genitourinaryHearingVisionDisorder,
      paralysis:
        primaryMemberMedicalAndLifeStyle?.paralysis ??
        initialValuesMedical.medicalDetails?.paralysis,
      brainNervousSystemDisorder:
        primaryMemberMedicalAndLifeStyle?.brainNervousSystemDisorder ??
        initialValuesMedical.medicalDetails?.brainNervousSystemDisorder,
      thyroidDisorder:
        primaryMemberMedicalAndLifeStyle?.thyroidDisorder ??
        initialValuesMedical.medicalDetails?.thyroidDisorder,
      chronicDigestiveDisorder:
        primaryMemberMedicalAndLifeStyle?.chronicDigestiveDisorder ??
        initialValuesMedical.medicalDetails?.chronicDigestiveDisorder,
      endocrineDisorder:
        primaryMemberMedicalAndLifeStyle?.endocrineDisorder ??
        initialValuesMedical.medicalDetails?.endocrineDisorder,
      anyOtherDisease:
        primaryMemberMedicalAndLifeStyle?.anyOtherDisease ??
        initialValuesMedical.medicalDetails?.anyOtherDisease,
      weightLossProgram:
        primaryMemberMedicalAndLifeStyle?.weightLossProgram ??
        initialValuesMedical.medicalDetails?.weightLossProgram,
      investigateCheckups:
        primaryMemberMedicalAndLifeStyle?.investigateCheckups ??
        initialValuesMedical.medicalDetails?.investigateCheckups,
      personalConsumptionSmoking:
        primaryMemberMedicalAndLifeStyle?.personalConsumptionSmoking ??
        initialValuesMedical.medicalDetails?.personalConsumptionSmoking,
      personalConsumptionTobacco:
        primaryMemberMedicalAndLifeStyle?.personalConsumptionTobacco ??
        initialValuesMedical.medicalDetails?.personalConsumptionTobacco,
      personalConsumptionAlcohol:
        primaryMemberMedicalAndLifeStyle?.personalConsumptionAlcohol ??
        initialValuesMedical.medicalDetails?.personalConsumptionAlcohol,
      isOccupationHazardious:
        primaryMemberMedicalAndLifeStyle?.isOccupationHazardious ??
        initialValuesMedical.medicalDetails?.isOccupationHazardious,
      mines: primaryMemberMedicalAndLifeStyle?.mines ?? initialValuesMedical.medicalDetails?.mines,
      explosives:
        primaryMemberMedicalAndLifeStyle?.explosives ??
        initialValuesMedical.medicalDetails?.explosives,
      radiation:
        primaryMemberMedicalAndLifeStyle?.radiation ??
        initialValuesMedical.medicalDetails?.radiation,
      corrosiveChemicals:
        primaryMemberMedicalAndLifeStyle?.corrosiveChemicals ??
        initialValuesMedical.medicalDetails?.corrosiveChemicals,
      hobbyQuery:
        primaryMemberMedicalAndLifeStyle?.hobbyQuery ??
        initialValuesMedical.medicalDetails?.hobbyQuery,
      aviation:
        primaryMemberMedicalAndLifeStyle?.aviation ?? initialValuesMedical.medicalDetails?.aviation,
      diving:
        primaryMemberMedicalAndLifeStyle?.diving ?? initialValuesMedical.medicalDetails?.diving,
      mountaineering:
        primaryMemberMedicalAndLifeStyle?.mountaineering ??
        initialValuesMedical.medicalDetails?.mountaineering,
      seaDiving:
        primaryMemberMedicalAndLifeStyle?.seaDiving ??
        initialValuesMedical.medicalDetails?.seaDiving,
      motorRacing:
        primaryMemberMedicalAndLifeStyle?.motorRacing ??
        initialValuesMedical.medicalDetails?.motorRacing,
      bungeeJumping:
        primaryMemberMedicalAndLifeStyle?.bungeeJumping ??
        initialValuesMedical.medicalDetails?.bungeeJumping,
      familyHealthQuery:
        primaryMemberMedicalAndLifeStyle?.familyHealthQuery ??
        initialValuesMedical.medicalDetails?.familyHealthQuery,
      femaleOrientedQuery:
        primaryMemberMedicalAndLifeStyle?.femaleOrientedQuery ??
        initialValuesMedical.medicalDetails?.femaleOrientedQuery
    }
  };

  return obj;
};

const bindLoanDetailsAPIData = (
  persistData: ILoanDetails,
  responseData: any,
  masterData: any = {}
) => {
  const newPersistData =
    responseData?.id === persistData.applicationId ? persistData : ({} as ILoanDetails);
  const existingPolicyDetials = responseData?.Members.filter(
    (val: any): any => val.isJointMember === false
  )[0];
  const {
    term,
    coverType,
    moratoriumPeriod,
    moratoriumPeriodWithoutInterest,
    premiumPaymentTerm,
    mode,
    loanCategory,
    coverOption,
    funding
  } = masterData;
  const obj: ILoanDetails = {
    ...newPersistData,
    loan: {
      lifeCoverOption: coverOption[responseData?.coverOption] || "",
      lifeCoverOptionCode: responseData?.coverOption ?? "",
      loanType: loanCategory[responseData?.loanCategory] || "",
      loanTypeCode: responseData?.loanCategory ?? "",
      loanAcNo: responseData?.loanAccountNo || "",
      interestPeriod: responseData?.interestPeriod
        .toLowerCase()
        .replace(regex.FirstCharCapital, (match: string) => match.toUpperCase()),
      moratoriumPeriodWith: moratoriumPeriod[responseData?.moratoriumPeriod] ?? "",
      moratoriumPeriodWithCode: responseData?.moratoriumPeriod ?? "",
      moratoriumPeriodWithout:
        moratoriumPeriodWithoutInterest[responseData?.moratoriumPeriod] ?? "",
      moratoriumPeriodWithoutCode: responseData?.moratoriumPeriod ?? "",
      emiAmount: responseData?.emiAmount || "",
      emiFrequency: responseData?.emiFrequency || "",
      lifeAssuredShareOfLoan: responseData?.lifeAssuredShareOfLoan || "",
      loanTerm: term[responseData?.term] || "",
      loanTermCode: responseData?.term ?? "",
      loanAmount: String(responseData?.loanAmount ?? ""),
      noOfCoBorrowers: responseData?.noOfCoBorrowers ?? "",
      share: responseData?.shareOfLoanPerc || "",
      loanInterestRate: responseData?.loanInterestRate || "",
      dateOfDisbursement:
        (responseData?.loanDisbursementDate &&
          moment(responseData?.loanDisbursementDate).format("DD/MM/YYYY")) ||
        "",
      lipAccNo: responseData?.lipAccountNumber || ""
    },
    plan: {
      coverOption: coverType[responseData?.coverType] || "",
      coverOptionCode: responseData?.coverType ?? "",
      deathSumInsured: responseData?.deathSumAssured || "",
      coverTerm: responseData?.policyTerm || responseData?.term || "",
      premiumPaymentTerm: premiumPaymentTerm[responseData?.premiumPaymentTerm] || "",
      premiumPaymentTermCode: responseData?.premiumPaymentTerm ?? ""
    },
    premiumFunding: {
      premiumFunding: funding[responseData?.funding] || "",
      premiumFundingCode: responseData?.funding ?? ""
    },
    premiumDetails: {
      premiumMode: mode[responseData?.mode] || "",
      premiumModeCode: responseData?.mode ?? "",
      totalPayment: responseData?.totalpremium || ""
    },
    existingPolicy: {
      existingLifeCover: existingPolicyDetials?.premiumDetails?.existingLifeCover || false,
      existingPolicyDetails: mapExistingPolicyDetails(
        existingPolicyDetials?.premiumDetails?.existingPolicyDetails || [
          existingLifeCoverInitialValuesObject
        ]
      )
    }
  };
  return obj;
};

const bindGeneralDetailsApiData = (persistData: any, responseData: any) => {
  const newPersistData = responseData?.id === persistData?.leadId ? persistData : {};
  const user = StorageService.getFromLocalStorage("user");
  const obj = {
    // ...newPersistData,
    applicationNumber: newPersistData?.applicationNumber || responseData?.applicationNo || "",
    serviceBranchCode: newPersistData?.serviceBranchCode || responseData?.solId || "",
    serviceBranchName: newPersistData?.serviceBranchName || responseData?.bankBranchName || "",
    bankDistributorName: responseData?.partnerId?.toUpperCase() || "OTHERS",
    ageasFederalEmployeeCode: responseData?.QuoteIrmMapping?.irmCode || "",
    bankCustomerId: newPersistData?.bankCustomerId || responseData?.bankCustomerId || "",
    branchSalesManagerCode:
      newPersistData?.branchSalesManagerCode || responseData?.branchSalesManagerCode || "",
    typeOfLoan: newPersistData?.typeOfLoan || responseData?.typeOfLoan || "NEW",
    st1Code:
      (prePopulateST1Code?.includes(responseData?.partnerId) && user?.empCode) ||
      responseData?.st1Code ||
      "",
    isCoBorrower: responseData?.coBorrowerFlag || false,
    isGuarantor: responseData?.guarantorFlag || false,
    isPrimaryBorrower: responseData?.isPrimaryBorrower || false,
    isStaff: responseData?.staff === "yes",
    staffEmpCode: responseData?.staffEmpCode || "",
    staffCompany:
      (GENERAL_DETAILS_MAPPING?.companyName(responseData?.partnerId || "") as any)?.[
        responseData?.staffCompany
      ] || "",
    staffCompanyCode: responseData?.staffCompany || "",
    staffST2Code: responseData?.st2Code || "",
    masterPolicyNumber: responseData?.masterPolicyNumber || "",
    masterPolicyHolderName: responseData?.masterPolicyHolderName || "",
    assignmentFlag:
      responseData?.assignmentFlag !== null
        ? responseData?.assignmentFlag
        : responseData?.PartnerConfig?.showAssignmentFlag
  };
  return obj;
};

const bindCovidAndNriDetails = (persistData: any, responseData: any) => {
  const newPersistData = responseData?.id === persistData?.leadId ? persistData : {};
  const covidAndNriDetails = responseData?.Members.filter(
    (val: any): any => val.isJointMember === false
  )[0];
  const obj = {
    ...newPersistData,
    covidTest: {
      covidPositive: covidAndNriDetails?.covidDetails?.covidTest?.covidPositive ?? false,
      covidQuarantine: covidAndNriDetails?.covidDetails?.covidTest?.covidQuarantine || "",
      covidComplication: covidAndNriDetails?.covidDetails?.covidTest?.covidComplication || ""
    },
    covidVaccineDates: {
      covidVaccinated: covidAndNriDetails?.covidDetails?.covidVaccineDates?.covidVaccinated ?? true,
      dateOfFirstDose: covidAndNriDetails?.covidDetails?.covidVaccineDates?.dateOfFirstDose || "",
      dateOfSecondDose: covidAndNriDetails?.covidDetails?.covidVaccineDates?.dateOfSecondDose || "",
      dateOfBoosterDose:
        covidAndNriDetails?.covidDetails?.covidVaccineDates?.dateOfBoosterDose || ""
    },
    nriDetails: {
      currentCountry: covidAndNriDetails?.NRIDetails?.nriDetails?.currentCountry || "",
      currentCountryCode: covidAndNriDetails?.NRIDetails?.nriDetails?.currentCountryCode || "",
      cityOfResidence: covidAndNriDetails?.NRIDetails?.nriDetails?.cityOfResidence || "",
      lastDateOfEntryToIn: covidAndNriDetails?.NRIDetails?.nriDetails?.lastDateOfEntryToIn || "",
      exitDateFromIndia: covidAndNriDetails?.NRIDetails?.nriDetails?.exitDateFromIndia || "",
      durationOfStayAbroad: covidAndNriDetails?.NRIDetails?.nriDetails?.durationOfStayAbroad || "",
      purposeOfStayAbroad: covidAndNriDetails?.NRIDetails?.nriDetails?.purposeOfStayAbroad || "",
      insurancePurpose:
        newPersistData?.nriDetails?.insurancePurpose ||
        covidAndNriDetails?.NRIDetails?.nriDetails?.insurancePurpose ||
        ""
    },
    otherCountryTravel: {
      isOtherCountryTravel:
        covidAndNriDetails?.NRIDetails?.otherCountryTravel?.isOtherCountryTravel ?? false,
      countryName: covidAndNriDetails?.NRIDetails?.otherCountryTravel?.countryName || "",
      countryNameCode: covidAndNriDetails?.NRIDetails?.otherCountryTravel?.countryNameCode || "",
      duration: covidAndNriDetails?.NRIDetails?.otherCountryTravel?.duration || "",
      purpose: covidAndNriDetails?.NRIDetails?.otherCountryTravel?.purpose || ""
    },
    occupationDetails: {
      occupationNameAndRole:
        covidAndNriDetails?.NRIDetails?.occupationDetails?.occupationNameAndRole || ""
    },
    salaried: {
      isOtherPolicyOutsideIndia:
        covidAndNriDetails?.NRIDetails?.policyDetails?.isOtherPolicyOutsideIndia ?? false,
      isSalaried: covidAndNriDetails?.NRIDetails?.salaried?.isSalaried ?? false,
      companyName: covidAndNriDetails?.NRIDetails?.salaried?.companyName || "",
      designation: covidAndNriDetails?.NRIDetails?.salaried?.designation || "",
      currency: covidAndNriDetails?.NRIDetails?.salaried?.currency || "Rupee",
      monthlyIncome: covidAndNriDetails?.NRIDetails?.salaried?.monthlyIncome || ""
    },
    selfEmployed: {
      isSelfEmployed: covidAndNriDetails?.NRIDetails?.selfEmployed?.isSelfEmployed ?? false,
      grossTurnover: covidAndNriDetails?.NRIDetails?.selfEmployed?.grossTurnover || "",
      annualIncome: covidAndNriDetails?.NRIDetails?.selfEmployed?.annualIncome || ""
    },
    bankDetails: {
      nameOfTheBank: covidAndNriDetails?.NRIDetails?.bankDetails?.nameOfTheBank || "",
      branch: covidAndNriDetails?.NRIDetails?.bankDetails?.branch || "",
      accountNumber: covidAndNriDetails?.NRIDetails?.bankDetails?.accountNumber || ""
    },
    residence: {
      nameOfTheBankResidence:
        covidAndNriDetails?.NRIDetails?.residence?.nameOfTheBankResidence || ""
    },
    policyDetails: {
      isOtherPolicyOutsideIndia:
        covidAndNriDetails?.NRIDetails?.policyDetails?.isOtherPolicyOutsideIndia ?? false,
      insurerName: covidAndNriDetails?.NRIDetails?.policyDetails?.insurerName || "",
      sumAssured: covidAndNriDetails?.NRIDetails?.policyDetails?.sumAssured || "",
      premiumAccount: covidAndNriDetails?.NRIDetails?.policyDetails?.premiumAccount || "",
      policyStatus: covidAndNriDetails?.NRIDetails?.policyDetails?.policyStatus || "",
      dateOfInsurance: covidAndNriDetails?.NRIDetails?.policyDetails?.dateOfInsurance || ""
    }
  };
  return obj;
};

const mapMemberDate = (persistData: any, leadData: any) => {
  return persistData === leadData
    ? undefined
    : !persistData
    ? null
    : moment(persistData, "DD/MM/YYYY").format("YYYY-MM-DD");
};

const bindProposerGeneralPayload = (
  persistMemberData: GeneralDetails,
  leadMemberData: GeneralDetails
) => {
  const obj = {
    title: persistMemberData?.titleCode,
    gender: mapMemberDetail(persistMemberData?.genderCode, leadMemberData?.genderCode),
    firstName: mapMemberDetail(persistMemberData?.firstName, leadMemberData?.firstName),
    middleName: mapMemberDetail(persistMemberData?.middleName, leadMemberData?.middleName),
    lastName: mapMemberDetail(persistMemberData?.lastName, leadMemberData?.lastName),
    dob: mapMemberDate(persistMemberData?.dob, leadMemberData?.dob),
    maritalStatus: persistMemberData?.maritalStatusCode,
    nationality: persistMemberData?.nationalityCode,
    countryOfResidence:
      persistMemberData?.nationalityCode === "RES"
        ? "091"
        : persistMemberData?.countryOfResidenceCode,
    cityOfResidence: mapMemberDetail(
      persistMemberData?.cityOfResidence,
      leadMemberData?.cityOfResidence
    ),
    lastEntryToIndiaDate: mapMemberDate(
      persistMemberData?.dateOfLastEntry,
      leadMemberData?.dateOfLastEntry && leadMemberData?.dateOfLastEntry
    ),
    educationQualification: mapMemberDetail(
      persistMemberData?.educationQualificationCode,
      leadMemberData?.educationQualificationCode
    ),
    mobileNo: mapMemberDetail(persistMemberData?.mobileNo, leadMemberData?.mobileNo),
    email: mapMemberDetail(persistMemberData?.email, leadMemberData?.email),
    occupation: mapMemberDetail(persistMemberData?.occupationCode, leadMemberData?.occupationCode),
    organisationName: persistMemberData?.nameOfOrganization,
    designation: mapMemberDetail(persistMemberData?.designation, leadMemberData?.designation),
    annualIncome: mapMemberDetail(persistMemberData?.annualIncome, leadMemberData?.annualIncome),
    panNo: mapMemberDetail(persistMemberData?.panNo, leadMemberData?.panNo),
    natureOfWork: mapMemberDetail(persistMemberData?.natureOfWork, leadMemberData?.natureOfWork),
    subOccupation: mapMemberDetail(
      persistMemberData?.subOccupationCode,
      leadMemberData?.subOccupationCode
    ),
    relationshipWithProposer: "SELF",
    telePhoneNo: mapMemberDetail(persistMemberData?.telePhoneNo, leadMemberData?.telePhoneNo),
    requirementFlag: mapMemberDetail(
      persistMemberData?.requirementFlag,
      leadMemberData?.requirementFlag
    ),
    ...((persistMemberData?.UIDNo && {
      UIDNo: `********${persistMemberData?.UIDNo?.slice(-4)}` || null
    }) ||
      null),
    electronicAccount: mapMemberDetail(
      persistMemberData?.electronicAccount?.toLowerCase(),
      leadMemberData?.electronicAccount?.toLowerCase()
    ),
    eiaNumber: mapMemberDetail(persistMemberData?.eiaNumber, leadMemberData?.eiaNumber),
    businessOwner: persistMemberData?.businessOwner ?? false,
    housewifeFlag: persistMemberData?.housewifeFlag ?? false
  };
  return obj;
};

const bindProposerAddressPayload = (
  persistMemberData: AddressDetails,
  leadMemberData: AddressDetails
) => {
  const obj = {
    addressLine1: mapMemberDetail(
      persistMemberData.address?.address1,
      leadMemberData?.address?.address1
    ),
    addressLine2: mapMemberDetail(
      persistMemberData.address?.address2,
      leadMemberData?.address?.address2
    ),
    addressLine3: mapMemberDetail(
      persistMemberData.address?.address3,
      leadMemberData?.address?.address3
    ),
    pincode: persistMemberData.address?.pinCode || null,
    city: persistMemberData?.address?.cityCode || null,
    state: +persistMemberData?.address?.stateCode! || null
  };
  return obj;
};

const bindJointMemberPayload = (
  persistMemberData: IJointLifeAddendum,
  leadMemberData: IJointLifeAddendum,
  masterDataReducer: any
) => {
  const general = bindProposerGeneralPayload(persistMemberData.member, leadMemberData.member);
  const address = bindProposerAddressPayload(persistMemberData, leadMemberData);
  const obj = {
    ...general,
    ...address,
    relationshipWithProposer: mapMemberDetail(
      persistMemberData?.member?.relationshipCode,
      leadMemberData?.member?.relationshipCode
    ),
    isAddressSameAsProposer: persistMemberData?.isAddressProposer,
    jointCoBorrowerFlag: persistMemberData?.jointCoBorrowerFlag || false,
    jointGuarantorFlag: persistMemberData?.jointGuarantorFlag || false,
    jointPrimaryBorrowerFlag: persistMemberData?.jointPrimaryBorrowerFlag || false,
    jointHousewifeFlag: persistMemberData?.jointHousewifeFlag || false,
    // medicalAndLifeStyle: persistMemberData?.medicalDetails,
    ...((persistMemberData?.existingPolicy?.existingLifeCover && {
      premiumDetails: persistMemberData?.existingPolicy
    }) || { premiumDetails: {} })
  };
  return obj;
};

const mapReviewNomineeDetails = (nominee: any[]) => {
  const arr: NomineeFields[] = [];
  nominee?.forEach((data) => {
    const nomineeObj: NomineeFields = {
      fullName: data?.fullName || "",
      email: data?.email || "",
      gender: data?.Gender?.name || "",
      bankName: data?.bankName || "",
      bankAccountNumber: data?.bankAccountNumber || "",
      ifscCode: data?.ifscCode || "",
      permanentAddress: data?.permanentAddress || "",
      permanentPincode: data?.permanentPincode || "",
      relationship: data?.PrimaryRelationship?.name || "",
      appointeeBankAccountNumber: data?.appointeeBankAccountNumber || "",
      appointeeIfscCode: data?.appointeeIfscCode || "",
      appointeeBankName: data?.appointeeBankName || "",
      appointeePermanentAddress: data?.appointeePermanentAddress || "",
      appointeePermanentPincode: data?.appointeePermanentPincode || "",
      captureBankDetails: data?.captureBankDetails || false,
      captureAppointeeBankDetails: data?.captureAppointeeBankDetails || false,
      appointeeEmail: data?.appointeeEmail || "",
      title: data?.Title?.name || "",
      titleCode: data?.title || "",
      genderCode: data?.gender || "",
      appointeeMobileNo: data?.appointeeMobileNo || "",
      captureAppointeeAddress: data?.captureAppointeeAddress || false,
      appointeeGenderCode: data?.appointeeGender || "",
      appointeeRelationCode: data?.appointeeRelationCode || "",
      appointeeTitleCode: data?.appointeeTitle || "",
      captureAddress: data?.captureAddress || false,
      isAddressSame: data?.isAddressSame || false,
      isAppointeeAddressSameAsProposer: data?.isAppointeeAddressSameAsProposer || false,
      relationshipCode: data?.relationshipCode || "",
      dob: (data?.dob && moment(data?.dob).format("DD/MM/YYYY")) || "",
      appointeeName: data?.appointeeName || "",
      appointeeDob: (data?.appointeeDob && moment(data?.appointeeDob).format("DD/MM/YYYY")) || "",
      appointeeRelation: data?.AppointeeRelationship?.name || "",
      share: data?.sharePercentage || "",
      mobileNo: data?.mobileNo || "",
      isMinor: data?.isMinor || false,
      id: data?.id,
      address: data?.address || "",
      pincode: data?.pincode || "",
      appointeeGender: data?.AppointeeGender?.name || "",
      appointeePincode: data?.appointeePincode || "",
      appointeeAddress: data?.appointeeAddress || "",
      appointeeTitle: data?.AppointeeTitle?.name || ""
    };
    arr.push(nomineeObj);
  });
  return arr;
};

const bindProposerReviewData = (responseData: any) => {
  const proposerData = responseData?.Members?.filter((ele: any) => ele.isJointMember === false)[0];
  const obj: ProposerDetails = {
    general: {
      title: proposerData?.Salutation?.name || "",
      gender: proposerData?.Gender?.name || "",
      genderCode: proposerData?.gender || "",
      firstName: proposerData?.firstName || "",
      middleName: proposerData?.middleName || "",
      lastName: proposerData?.lastName || "",
      dob: (proposerData?.dob && moment(proposerData?.dob).format("DD/MM/YYYY")) || "",
      maritalStatus: proposerData?.MaritalStatus?.name || "",
      nationality:
        NaionalityOptions.nationality[proposerData?.nationality] ||
        NaionalityOptions.nationality[""],
      nationalityCode: proposerData?.nationality || "",
      countryOfResidence: proposerData?.Country?.name || "",
      countryOfResidenceCode: proposerData?.Country?.code || "",
      cityOfResidence: proposerData?.cityOfResidence || "",
      dateOfLastEntry:
        (proposerData?.lastEntryToIndiaDate &&
          moment(proposerData?.lastEntryToIndiaDate).format("DD/MM/YYYY")) ||
        "",
      educationQualification: proposerData?.Education?.name || "",
      mobileNo: proposerData?.mobileNo || "",
      email: proposerData?.email || "",
      occupation: proposerData?.Occupation?.name || "",
      subOccupation: proposerData?.SubOccupation?.name || "",
      nameOfOrganization: proposerData?.organisationName || "",
      designation: proposerData?.designation || "",
      annualIncome: proposerData?.annualIncome || "",
      panNo: proposerData?.panNo || "",
      natureOfWork: proposerData?.natureOfWork || "",
      telePhoneNo: proposerData?.telePhoneNo || "",
      requirementFlag: proposerData?.requirementFlag,
      UIDNo: proposerData?.UIDNo || "",
      electronicAccount: proposerData?.electronicAccount || "",
      eiaNumber: proposerData?.eiaNumber || "",
      businessOwner: proposerData?.businessOwner || false,
      housewifeFlag: proposerData?.housewifeFlag || false
    },
    address: {
      address: {
        address1: proposerData?.addressLine1 || "",
        address2: proposerData?.addressLine2 || "",
        address3: proposerData?.addressLine3 || "",
        pinCode: proposerData?.Pincode?.pincode || "",
        city: proposerData?.Pincode?.city,
        state: proposerData?.Pincode?.state
      }
    },
    nominee: {
      nominee: proposerData?.Nominees?.length
        ? mapReviewNomineeDetails(proposerData?.Nominees)
        : [nomineeIndividualField]
    }
  };
  // obj.general!.titleCode = findKeysByValue(masterData?.salutationDetails, obj.general!.title);
  // obj.general!.genderCode = findKeysByValue(masterData?.genderDetails, obj.general!.gender);
  // obj.general!.educationQualificationCode = findKeysByValue(
  //   masterData?.educationDetails,
  //   obj.general!.educationQualification
  // );
  // obj.general!.occupationCode = findKeysByValue(
  //   masterData?.occupationDetails,
  //   obj.general!.occupation
  // );
  // obj.general!.maritalStatusCode = findKeysByValue(
  //   masterData?.maritalstatusDetails,
  //   obj.general!.maritalStatus
  // );
  return obj;
};

const bindJointLifeReviewData = (responseData: any) => {
  const jointMemberData = responseData?.Members?.filter(
    (ele: any) => ele.isJointMember === true
  )[0];
  const jointMedicalData = jointMemberData?.medicalAndLifeStyle;
  const jointMedicalInitialValues = initialValuesJointLife?.medicalDetails;
  const obj: any = {
    member: {
      relationship: jointMemberData?.Relationship?.name || "",
      title: jointMemberData?.Salutation?.name || "",
      gender: jointMemberData?.Gender?.name || "",
      genderCode: jointMemberData?.gender || "",
      firstName: jointMemberData?.firstName || "",
      middleName: jointMemberData?.middleName || "",
      lastName: jointMemberData?.lastName || "",
      dob: (jointMemberData?.dob && moment(jointMemberData?.dob).format("DD/MM/YYYY")) || "",
      maritalStatus: jointMemberData?.MaritalStatus?.name || "",
      nationality:
        NaionalityOptions.nationality[jointMemberData?.nationality] ||
        NaionalityOptions.nationality[""],
      nationalityCode: jointMemberData?.nationality || "",
      countryOfResidence: jointMemberData?.Country?.name || "",
      countryOfResidenceCode: jointMemberData?.Country?.code || "",
      cityOfResidence: jointMemberData?.cityOfResidence || "",
      dateOfLastEntry:
        (jointMemberData?.lastEntryToIndiaDate &&
          moment(jointMemberData?.lastEntryToIndiaDate).format("DD/MM/YYYY")) ||
        "",
      educationQualification: jointMemberData?.Education?.name || "",
      mobileNo: jointMemberData?.mobileNo || "",
      email: jointMemberData?.email || "",
      occupation: jointMemberData?.Occupation?.name || "",
      occupationCode: jointMemberData?.occupation || "",
      subOccupation: jointMemberData?.SubOccupation?.name || "",
      nameOfOrganization: jointMemberData?.organisationName || "",
      designation: jointMemberData?.designation || "",
      annualIncome: jointMemberData?.annualIncome || "",
      panNo: jointMemberData?.panNo || "",
      natureOfWork: jointMemberData?.natureOfWork || "",
      telePhoneNo: jointMemberData?.telePhoneNo || "",
      UIDNo: jointMemberData?.UIDNo || "",
      electronicAccount: jointMemberData?.electronicAccount || "",
      eiaNumber: jointMemberData?.eiaNumber || "",
      businessOwner: jointMemberData?.businessOwner || false
    },
    address: {
      address1: jointMemberData?.addressLine1 || "",
      address2: jointMemberData?.addressLine2 || "",
      address3: jointMemberData?.addressLine3 || "",
      pinCode: jointMemberData?.Pincode?.pincode || "",
      city: jointMemberData?.Pincode?.city,
      state: jointMemberData?.Pincode?.state
    },
    existingPolicy: {
      existingLifeCover: jointMemberData?.premiumDetails?.existingLifeCover || false,
      existingPolicyDetails: mapExistingPolicyDetails(
        jointMemberData?.premiumDetails?.existingPolicyDetails || [
          existingLifeCoverInitialValuesObject
        ]
      )
    },
    medicalDetails: {
      declare:
        jointMemberData?.medicalAndLifeStyle?.declare ??
        initialValuesJointLife?.medicalDetails?.declare,
      medicalHealth:
        jointMemberData?.medicalAndLifeStyle?.medicalHealth ??
        initialValuesJointLife?.medicalDetails?.medicalHealth,
      weight:
        jointMemberData?.medicalAndLifeStyle?.weight ??
        initialValuesJointLife?.medicalDetails?.weight,
      height:
        jointMemberData?.medicalAndLifeStyle?.height ??
        initialValuesJointLife?.medicalDetails?.height,

      measurement:
        jointMemberData?.medicalAndLifeStyle?.measurement ||
        initialValuesJointLife?.medicalDetails?.measurement,
      familyBackground:
        jointMemberData?.medicalAndLifeStyle?.familyBackground ??
        initialValuesJointLife?.medicalDetails?.familyBackground,
      diabetes:
        jointMemberData?.medicalAndLifeStyle?.diabetes ??
        initialValuesJointLife?.medicalDetails?.diabetes,
      highBloodPressure:
        jointMemberData?.medicalAndLifeStyle?.highBloodPressure ??
        initialValuesJointLife?.medicalDetails?.highBloodPressure,
      stroke:
        jointMemberData?.medicalAndLifeStyle?.stroke ??
        initialValuesJointLife?.medicalDetails?.stroke,
      asthma:
        jointMemberData?.medicalAndLifeStyle?.asthma ??
        initialValuesJointLife?.medicalDetails?.asthma,
      epilepsy:
        jointMemberData?.medicalAndLifeStyle?.epilepsy ??
        initialValuesJointLife?.medicalDetails?.epilepsy,
      liverDisease:
        jointMemberData?.medicalAndLifeStyle?.liverDisease ??
        initialValuesJointLife?.medicalDetails?.liverDisease,
      kidneyDisease:
        jointMemberData?.medicalAndLifeStyle?.kidneyDisease ??
        initialValuesJointLife?.medicalDetails?.kidneyDisease,
      bloodDisorder:
        jointMemberData?.medicalAndLifeStyle?.bloodDisorder ??
        initialValuesJointLife?.medicalDetails?.bloodDisorder,
      tumor:
        jointMemberData?.medicalAndLifeStyle?.tumor ??
        initialValuesJointLife?.medicalDetails?.tumor,
      anxiety:
        jointMemberData?.medicalAndLifeStyle?.anxiety ??
        initialValuesJointLife?.medicalDetails?.anxiety,
      aids:
        jointMemberData?.medicalAndLifeStyle?.aids ?? initialValuesJointLife?.medicalDetails?.aids,
      smoker:
        jointMemberData?.medicalAndLifeStyle?.smoker ??
        initialValuesJointLife?.medicalDetails?.smoker,
      cigaratte:
        jointMemberData?.medicalAndLifeStyle?.cigaratte ??
        initialValuesJointLife?.medicalDetails?.cigaratte,
      bidi:
        jointMemberData?.medicalAndLifeStyle?.bidi ?? initialValuesJointLife?.medicalDetails?.bidi,
      cigar:
        jointMemberData?.medicalAndLifeStyle?.cigar ??
        initialValuesJointLife?.medicalDetails?.cigar,
      panMasalaAmount:
        jointMemberData?.medicalAndLifeStyle?.panMasalaAmount ??
        initialValuesJointLife?.medicalDetails?.panMasalaAmount,
      panMasala:
        jointMemberData?.medicalAndLifeStyle?.panMasala ??
        initialValuesJointLife?.medicalDetails?.panMasala,
      gutkha:
        jointMemberData?.medicalAndLifeStyle?.gutkha ??
        initialValuesJointLife?.medicalDetails?.gutkha,
      chewing:
        jointMemberData?.medicalAndLifeStyle?.chewing ??
        initialValuesJointLife?.medicalDetails?.chewing,
      cigaratteAmount:
        jointMemberData?.medicalAndLifeStyle?.cigaratteAmount ??
        initialValuesJointLife?.medicalDetails?.cigaratteAmount,
      cigarAmount:
        jointMemberData?.medicalAndLifeStyle?.cigarAmount ??
        initialValuesJointLife?.medicalDetails?.cigarAmount,
      bidiAmount:
        jointMemberData?.medicalAndLifeStyle?.bidiAmount ??
        initialValuesJointLife?.medicalDetails?.bidiAmount,
      gutkhaAmount:
        jointMemberData?.medicalAndLifeStyle?.gutkhaAmount ??
        initialValuesJointLife?.medicalDetails?.gutkhaAmount,
      chewingAmount:
        jointMemberData?.medicalAndLifeStyle?.chewingAmount ??
        initialValuesJointLife?.medicalDetails?.chewingAmount,
      alcohol:
        jointMemberData?.medicalAndLifeStyle?.alcohol ??
        initialValuesJointLife?.medicalDetails?.alcohol,
      drugs:
        jointMemberData?.medicalAndLifeStyle?.drugs ??
        initialValuesJointLife?.medicalDetails?.drugs,
      disability:
        jointMemberData?.medicalAndLifeStyle?.disability ??
        initialValuesJointLife?.medicalDetails?.disability,
      gyneComplications:
        jointMemberData?.medicalAndLifeStyle?.gyneComplications ??
        initialValuesJointLife?.medicalDetails?.gyneComplications,
      pregnant:
        jointMemberData?.medicalAndLifeStyle?.pregnant ??
        initialValuesJointLife?.medicalDetails?.pregnant,
      pregnancyDuration:
        jointMemberData?.medicalAndLifeStyle?.pregnancyDuration ??
        initialValuesJointLife?.medicalDetails?.pregnancyDuration,
      remarks:
        jointMemberData?.medicalAndLifeStyle?.remarks ??
        initialValuesJointLife?.medicalDetails?.remarks,
      beer:
        jointMemberData?.medicalAndLifeStyle?.beer ?? initialValuesJointLife?.medicalDetails?.beer,
      wine:
        jointMemberData?.medicalAndLifeStyle?.wine ?? initialValuesJointLife?.medicalDetails?.wine,

      liquor:
        jointMemberData?.medicalAndLifeStyle?.liquor ??
        initialValuesJointLife?.medicalDetails?.liquor,
      lessThanOnce:
        jointMemberData?.medicalAndLifeStyle?.lessThanOnce ??
        initialValuesJointLife?.medicalDetails?.lessThanOnce,
      moreThanOnce:
        jointMemberData?.medicalAndLifeStyle?.moreThanOnce ??
        initialValuesJointLife?.medicalDetails?.moreThanOnce,
      once:
        jointMemberData?.medicalAndLifeStyle?.once ?? initialValuesJointLife?.medicalDetails?.once,
      daily:
        jointMemberData?.medicalAndLifeStyle?.daily ??
        initialValuesJointLife?.medicalDetails?.daily,
      alcoholAmount:
        jointMemberData?.medicalAndLifeStyle?.alcoholAmount ??
        initialValuesJointLife?.medicalDetails?.alcoholAmount,
      familyHealthHistory:
        jointMemberData?.medicalAndLifeStyle?.familyHealthHistory ??
        responseData?.familyHealthHistory ??
        initialValuesJointLife?.medicalDetails?.familyHealthHistory,
      familyMedicalHistory: familyMedicalHistory(
        jointMemberData?.medicalAndLifeStyle?.familyMedicalHistory ??
          initialValuesJointLife?.medicalDetails?.familyMedicalHistory
      ),
      alcoholConsumptionSince:
        jointMedicalData?.alcoholConsumptionSince ??
        jointMedicalInitialValues?.alcoholConsumptionSince,
      anaemia: jointMedicalData?.anaemia ?? jointMedicalInitialValues?.anaemia,
      anxietyDepression:
        jointMedicalData?.anxietyDepression ?? jointMedicalInitialValues?.anxietyDepression,
      arthritis: jointMedicalData?.arthritis ?? jointMedicalInitialValues?.arthritis,
      asthamaTuberculosis:
        jointMedicalData?.asthamaTuberculosis ?? jointMedicalInitialValues?.asthamaTuberculosis,
      bloodPressureHeartAttack:
        jointMedicalData?.bloodPressureHeartAttack ??
        jointMedicalInitialValues?.bloodPressureHeartAttack,
      cancerTumor: jointMedicalData?.cancerTumor ?? jointMedicalInitialValues?.cancerTumor,
      diabetesAndSugar:
        jointMedicalData?.diabetesAndSugar ?? jointMedicalInitialValues?.diabetesAndSugar,

      existingApplication:
        jointMedicalData?.existingApplication ?? jointMedicalInitialValues?.existingApplication,

      familyHealth: jointMedicalData?.familyHealth ?? jointMedicalInitialValues?.familyHealth,

      hospitalisation:
        jointMedicalData?.hospitalisation ?? jointMedicalInitialValues?.hospitalisation,

      indigestion: jointMedicalData?.indigestion ?? jointMedicalInitialValues?.indigestion,

      kidneyStoneBloodUrine:
        jointMedicalData?.kidneyStoneBloodUrine ?? jointMedicalInitialValues?.kidneyStoneBloodUrine,

      majorDisorder: jointMedicalData?.majorDisorder ?? jointMedicalInitialValues?.majorDisorder,
      occupationEnquiry:
        jointMedicalData?.occupationEnquiry ?? jointMedicalInitialValues?.occupationEnquiry,
      otherDisease: jointMedicalData?.otherDisease ?? jointMedicalInitialValues?.otherDisease,
      otherDiseaseDetails:
        jointMedicalData?.otherDiseaseDetails ?? jointMedicalInitialValues?.otherDiseaseDetails,
      smokingConsumptionSince:
        jointMedicalData?.smokingConsumptionSince ??
        jointMedicalInitialValues?.smokingConsumptionSince,
      strokeParalysis:
        jointMedicalData?.strokeParalysis ?? jointMedicalInitialValues?.strokeParalysis,

      thyroid: jointMedicalData?.thyroid ?? jointMedicalInitialValues?.thyroid,
      underTreatment: jointMedicalData?.underTreatment ?? jointMedicalInitialValues?.underTreatment,
      heartDisease: jointMedicalData?.heartDisease ?? jointMedicalInitialValues?.heartDisease,
      lungDisease: jointMedicalData?.lungDisease ?? jointMedicalInitialValues?.lungDisease,
      highCholesterol:
        jointMedicalData?.highCholesterol ?? jointMedicalInitialValues?.highCholesterol,
      hivAidsSTI: jointMedicalData?.hivAidsSTI ?? jointMedicalInitialValues?.hivAidsSTI,
      congenitalDefect:
        jointMedicalData?.congenitalDefect ?? jointMedicalInitialValues?.congenitalDefect,
      genitourinaryHearingVisionDisorder:
        jointMedicalData?.genitourinaryHearingVisionDisorder ??
        jointMedicalInitialValues?.genitourinaryHearingVisionDisorder,
      paralysis: jointMedicalData?.paralysis ?? jointMedicalInitialValues?.paralysis,
      brainNervousSystemDisorder:
        jointMedicalData?.brainNervousSystemDisorder ??
        jointMedicalInitialValues?.brainNervousSystemDisorder,
      thyroidDisorder:
        jointMedicalData?.thyroidDisorder ?? jointMedicalInitialValues?.thyroidDisorder,
      chronicDigestiveDisorder:
        jointMedicalData?.chronicDigestiveDisorder ??
        jointMedicalInitialValues?.chronicDigestiveDisorder,
      endocrineDisorder:
        jointMedicalData?.endocrineDisorder ?? jointMedicalInitialValues?.endocrineDisorder,
      anyOtherDisease:
        jointMedicalData?.anyOtherDisease ?? jointMedicalInitialValues?.anyOtherDisease,
      weightLossProgram:
        jointMedicalData?.weightLossProgram ?? jointMedicalInitialValues?.weightLossProgram,
      investigateCheckups:
        jointMedicalData?.investigateCheckups ?? jointMedicalInitialValues?.investigateCheckups,
      personalConsumptionSmoking:
        jointMedicalData?.personalConsumptionSmoking ??
        jointMedicalInitialValues?.personalConsumptionSmoking,
      personalConsumptionTobacco:
        jointMedicalData?.personalConsumptionTobacco ??
        jointMedicalInitialValues?.personalConsumptionTobacco,
      personalConsumptionAlcohol:
        jointMedicalData?.personalConsumptionAlcohol ??
        jointMedicalInitialValues?.personalConsumptionAlcohol,
      isOccupationHazardious:
        jointMedicalData?.isOccupationHazardious ??
        jointMedicalInitialValues?.isOccupationHazardious,
      mines: jointMedicalData?.mines ?? jointMedicalInitialValues?.mines,
      explosives: jointMedicalData?.explosives ?? jointMedicalInitialValues?.explosives,
      radiation: jointMedicalData?.radiation ?? jointMedicalInitialValues?.radiation,
      corrosiveChemicals:
        jointMedicalData?.corrosiveChemicals ?? jointMedicalInitialValues?.corrosiveChemicals,
      hobbyQuery: jointMedicalData?.hobbyQuery ?? jointMedicalInitialValues?.hobbyQuery,
      aviation: jointMedicalData?.aviation ?? jointMedicalInitialValues?.aviation,
      diving: jointMedicalData?.diving ?? jointMedicalInitialValues?.diving,
      mountaineering: jointMedicalData?.mountaineering ?? jointMedicalInitialValues?.mountaineering,
      seaDiving: jointMedicalData?.seaDiving ?? jointMedicalInitialValues?.seaDiving,
      motorRacing: jointMedicalData?.motorRacing ?? jointMedicalInitialValues?.motorRacing,
      bungeeJumping: jointMedicalData?.bungeeJumping ?? jointMedicalInitialValues?.bungeeJumping,
      familyHealthQuery:
        jointMedicalData?.familyHealthQuery ?? jointMedicalInitialValues?.familyHealthQuery,
      femaleOrientedQuery:
        jointMedicalData?.femaleOrientedQuery ?? jointMedicalInitialValues?.femaleOrientedQuery
    },
    covidAndNriDetails: {
      covidTest: {
        covidPositive: jointMemberData?.covidDetails?.covidTest?.covidPositive ?? false,
        covidQuarantine: jointMemberData?.covidDetails?.covidTest?.covidQuarantine || "",
        covidComplication: jointMemberData?.covidDetails?.covidTest?.covidComplication || ""
      },
      covidVaccineDates: {
        covidVaccinated: jointMemberData?.covidDetails?.covidVaccineDates?.covidVaccinated ?? true,
        dateOfFirstDose: jointMemberData?.covidDetails?.covidVaccineDates?.dateOfFirstDose || "",
        dateOfSecondDose: jointMemberData?.covidDetails?.covidVaccineDates?.dateOfSecondDose || "",
        dateOfBoosterDose: jointMemberData?.covidDetails?.covidVaccineDates?.dateOfBoosterDose || ""
      },
      nriDetails: {
        currentCountry: jointMemberData?.NRIDetails?.nriDetails?.currentCountry || "",
        currentCountryCode: jointMemberData?.NRIDetails?.nriDetails?.currentCountryCode || "",
        cityOfResidence: jointMemberData?.NRIDetails?.nriDetails?.cityOfResidence || "",
        lastDateOfEntryToIn: jointMemberData?.NRIDetails?.nriDetails?.lastDateOfEntryToIn || "",
        exitDateFromIndia: jointMemberData?.NRIDetails?.nriDetails?.exitDateFromIndia || "",
        durationOfStayAbroad: jointMemberData?.NRIDetails?.nriDetails?.durationOfStayAbroad || "",
        purposeOfStayAbroad: jointMemberData?.NRIDetails?.nriDetails?.purposeOfStayAbroad || "",
        insurancePurpose:
          jointMemberData?.nriDetails?.insurancePurpose ||
          jointMemberData?.NRIDetails?.nriDetails?.insurancePurpose ||
          ""
      },
      otherCountryTravel: {
        isOtherCountryTravel:
          jointMemberData?.NRIDetails?.otherCountryTravel?.isOtherCountryTravel ?? false,
        countryName: jointMemberData?.NRIDetails?.otherCountryTravel?.countryName || "",
        countryNameCode: jointMemberData?.NRIDetails?.otherCountryTravel?.countryNameCode || "",
        duration: jointMemberData?.NRIDetails?.otherCountryTravel?.duration || "",
        purpose: jointMemberData?.NRIDetails?.otherCountryTravel?.purpose || ""
      },
      occupationDetails: {
        occupationNameAndRole:
          jointMemberData?.NRIDetails?.occupationDetails?.occupationNameAndRole || ""
      },
      salaried: {
        isOtherPolicyOutsideIndia:
          jointMemberData?.NRIDetails?.policyDetails?.isOtherPolicyOutsideIndia ?? false,
        isSalaried: jointMemberData?.NRIDetails?.salaried?.isSalaried ?? false,
        companyName: jointMemberData?.NRIDetails?.salaried?.companyName || "",
        designation: jointMemberData?.NRIDetails?.salaried?.designation || "",
        currency: jointMemberData?.NRIDetails?.salaried?.currency || "Rupee",
        monthlyIncome: jointMemberData?.NRIDetails?.salaried?.monthlyIncome || ""
      },
      selfEmployed: {
        isSelfEmployed: jointMemberData?.NRIDetails?.selfEmployed?.isSelfEmployed ?? false,
        grossTurnover: jointMemberData?.NRIDetails?.selfEmployed?.grossTurnover || "",
        annualIncome: jointMemberData?.NRIDetails?.selfEmployed?.annualIncome || ""
      },
      bankDetails: {
        nameOfTheBank: jointMemberData?.NRIDetails?.bankDetails?.nameOfTheBank || "",
        branch: jointMemberData?.NRIDetails?.bankDetails?.branch || "",
        accountNumber: jointMemberData?.NRIDetails?.bankDetails?.accountNumber || ""
      },
      residence: {
        nameOfTheBankResidence: jointMemberData?.NRIDetails?.residence?.nameOfTheBankResidence || ""
      },
      policyDetails: {
        isOtherPolicyOutsideIndia:
          jointMemberData?.NRIDetails?.policyDetails?.isOtherPolicyOutsideIndia ?? false,
        insurerName: jointMemberData?.NRIDetails?.policyDetails?.insurerName || "",
        sumAssured: jointMemberData?.NRIDetails?.policyDetails?.sumAssured || "",
        premiumAccount: jointMemberData?.NRIDetails?.policyDetails?.premiumAccount || "",
        policyStatus: jointMemberData?.NRIDetails?.policyDetails?.policyStatus || "",
        dateOfInsurance: jointMemberData?.NRIDetails?.policyDetails?.dateOfInsurance || ""
      }
    },
    medicalDetailsV2: jointMemberData?.medicalAndLifeStyle || null
  };
  return obj;
};

function handelIndianCurrencyChange(evt: any, formik: any) {
  const { value, name } = evt.target;
  const cursorPosition = evt.target.selectionStart;
  const unformattedValue = value.replace(/,/g, "");
  formik.setFieldValue(name, unformattedValue);
  setTimeout(() => {
    const formattedValue = onChangeIndianCurrency(unformattedValue);
    const adjustedCursorPosition = cursorPosition + (formattedValue.length - value.length);
    evt.target.setSelectionRange(adjustedCursorPosition, adjustedCursorPosition);
  });
}

function onChangeIndianCurrency(value: number | string) {
  if (value == null) return value;
  const newValue = value.toString().replace(/,/g, "");
  const formattedValue = newValue.replace(regex.indianCurrency, ",");
  return formattedValue;
}

function maskUID(value: any) {
  return value.slice(0, 4) + "****" + value.slice(-4);
}

const handleUppercaseChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
) => {
  const cursorPosition = e.target.selectionStart;
  const uppercaseValue = e.target.value.toUpperCase();

  handleChange({
    target: {
      name: e.target.name,
      value: uppercaseValue
    }
  } as React.ChangeEvent<HTMLInputElement>);

  setTimeout(() => {
    e.target.setSelectionRange(cursorPosition, cursorPosition);
  }, 0);
};

const bindJointFreezePayload = (data: GeneralDetails, leadId: string) => {
  const obj = {
    leadId,
    gender: mapMemberDetail(data?.jointGenderCode, ""),
    firstName: mapMemberDetail(data?.jointFirstName, ""),
    middleName: mapMemberDetail(data?.jointMiddleName, ""),
    lastName: mapMemberDetail(data?.jointLastName, ""),
    dob: data?.jointDob && mapMemberDate(data?.jointDob, ""),
    mobileNo: mapMemberDetail(data?.jointMobileNo, ""),
    annualIncome: String(mapMemberDetail(Math.round(Number(data?.jointAnnualIncome)), "")),
    panNo: mapMemberDetail(data?.jointPan, ""),
    isJointMember: true
    // requirementFlag: false
    // telePhoneNo: mapMemberDetail(data?.jointTelePhoneNo, "")
    // relationshipWithProposer: data?.jointRelationshipCode || ""
  };
  return obj;
};

const bindJointFreezePayloadForRedux = (data: GeneralDetails) => {
  const obj = {
    title: data?.jointGenderCode === "F" ? "Ms." : "Mr",
    titleCode: data?.jointGenderCode === "F" ? "MS" : "MR",
    gender: data?.jointGender || "",
    genderCode: data?.jointGenderCode || "",
    firstName: data?.jointFirstName || "",
    middleName: data?.jointMiddleName || "",
    lastName: data?.jointLastName || "",
    dob: data?.jointDob || "",
    annualIncome: String(Math.round(Number(data?.jointAnnualIncome))) || "",
    panNo: data?.jointPan || "",
    mobileNo: data?.jointMobileNo || ""
    // relationship: data?.jointRelationship || "",
    // relationshipCode: data?.jointRelationshipCode || ""
  };
  return obj;
};

const mapProportionateMembers = (data: ProportionateFields[]) => {
  const payload = data?.reduce((acc: Record<string, any>, data: ProportionateFields) => {
    const members = {
      name: data.nameOfProportionateLife,
      dob: mapMemberDate(data.proprtionateDob, ""),
      sharePercentage: Number(data.proprtionatePercent),
      sumAssured: Number(data.proprtionateSumAssured),
      gender: data.genderCode
    };
    acc.push(members);
    return acc;
  }, []);
  return payload;
};

const bindProportionatePayload = (data: GeneralDetails, leadId: string) => {
  const obj = {
    leadId,
    primaryPercentage: Number(data.primaryProportionatePercent),
    sumAssured: Number(data.primarySumAssured),
    loanAmount: Number(data.totalLoanAmountOpted),
    members: mapProportionateMembers(data.proportionate!)
  };
  return obj;
};

const bindNewLeadDetailsApiData = (responseData: any) => {
  const obj = {
    productId: responseData?.productId ? Number(responseData.productId) : null,
    applicationNumber: responseData?.applicationNumber || "",
    loanType: responseData?.loanType || "",
    loanAccountNo: responseData?.loanAccountNo || "",
    channel: responseData?.channel || "",
    channelCode: responseData?.channelCode || "",
    partnerId: responseData?.partnerId || "",
    bankVertical: responseData?.bankVertical || "",
    solId: responseData?.solId || "",
    lgCode: responseData?.lgCode || "",
    firstName: responseData?.firstName || "",
    middleName: responseData?.middleName || "",
    lastName: responseData?.lastName || "",
    customerDOB: responseData?.customerDOB || "",
    customerMobileNumber: responseData?.customerMobileNumber || "",
    customerPAN: responseData?.customerPAN || "",
    customerEmail: responseData?.customerEmail || "",
    customerGender: responseData?.customerGender || "",
    applicationSignedDate: responseData?.applicationSignedDate || "",
    loanAmount: responseData?.loanAmount,
    loanTerm: responseData?.loanTerm,
    policyTerm: responseData?.policyTerm,
    premiumPaymentTerm: responseData.premiumPaymentTerm,
    loanInterestRate: responseData?.loanInterestRate,
    sumAssured: responseData.loanAmount ?? responseData.sumAssured,
    premiumPaymentTermCode: responseData?.premiumPaymentTermCode ?? "",
    files: responseData?.files || [...[fileInitialValue]],
    emiFrequency: responseData?.emiFrequency || "",
    paymentMode: responseData?.paymentMode || "",
    chequeNo: responseData?.chequeNo || "",
    chequeDate: responseData?.chequeDate || "",
    chequeBankName: responseData?.chequeBankName || "",
    chequeBranchName: responseData?.chequeBranchName || "",
    chequeAmount: responseData?.chequeAmount || 0
  };
  return obj;
};

const getAssigneeName = (data: Record<string, any>) => {
  return getFullName(data?.firstName, data?.lastName);
};

const bindAssignmentClauseApiData = (
  responseData: any,
  address: SecondaryDetails,
  masterData: Record<string, any>
) => {
  const assigneeName = getAssigneeName(
    responseData?.Members?.filter((member: any) => !member?.isJointMember)?.[0]
  );
  const jointAssigneeName = getAssigneeName(
    responseData?.Members?.filter((member: any) => member?.isJointMember)?.[0]
  );
  const isSREI = responseData?.partnerId === partners.SREI;
  const obj = {
    applicationId: responseData?.AssignmentNotice?.id,
    assignor: assigneeName || "",
    assignorJoint: jointAssigneeName || "",
    assignorName:
      responseData?.AssignmentNotice?.assigneeName ||
      responseData?.PartnerConfig?.assigneeName ||
      "",
    assigmentAt:
      responseData?.AssignmentNotice?.assigmentAt || responseData?.CWHs?.[0]?.branchName || "",
    signedDate: responseData?.AssignmentNotice?.signedDate
      ? moment(responseData?.AssignmentNotice?.signedDate).format("DD/MM/YYYY")
      : responseData?.applicationSignedDate
      ? moment(responseData?.applicationSignedDate).format("DD/MM/YYYY")
      : "",
    place: address?.city || "",
    placeCode: address?.cityCode || "",
    reasonForAssigment: responseData?.AssignmentNotice?.reasonForAssignment || "Loan Protection",

    witnessName:
      responseData?.AssignmentNotice?.witnessName ||
      (!isSREI && responseData?.QuoteIrmMapping?.irmName) ||
      "",
    address:
      responseData?.AssignmentNotice?.address ||
      (!isSREI && responseData?.CWHs?.[0]?.bankBranchAddress) ||
      "",
    pincode:
      responseData?.AssignmentNotice?.pincode ||
      (!isSREI && responseData?.CWHs?.[0]?.pinCode) ||
      "",
    occupation:
      masterData?.assignmentOccupationDetails?.[responseData?.AssignmentNotice?.occupation] || "",
    occupationCode: responseData?.AssignmentNotice?.occupation || ""
  };
  return obj;
};

const bindAssignmentPayload = (responseData: any) => {
  const baseObj = bindAssignmentClauseApiData(responseData, responseData, {});
  const obj = {
    ...baseObj,
    place: responseData?.AssignmentNotice?.City?.name || baseObj.place,
    placeCode: responseData?.AssignmentNotice?.City?.code || baseObj.placeCode,
    witnessName: responseData?.AssignmentNotice?.witnessName || baseObj.witnessName,
    address: responseData?.AssignmentNotice?.address || baseObj.address,
    pincode: responseData?.AssignmentNotice?.pincode || baseObj.pincode,
    occupation: responseData?.AssignmentNotice?.Occupation?.name || baseObj.occupation,
    assigmentAt: responseData?.AssignmentNotice?.assignmentAt || baseObj.assigmentAt,
    reasonForAssigment:
      responseData?.AssignmentNotice?.reasonForAssignment || baseObj.reasonForAssigment,
    signedDate: responseData?.AssignmentNotice?.signedDate
      ? moment(responseData?.AssignmentNotice?.signedDate).format("DD/MM/YYYY")
      : baseObj.signedDate
  };

  return obj;
};

const getQuestionnaireVersion = (members: Record<string, any>[], proposalStatus: string) => {
  const currentMember = members?.filter((member) => !member.isJoint)[0];
  const isNewQuestionnaire =
    currentMember?.medicalAndLifeStyle?.version === 3 ||
    !currentMember?.medicalAndLifeStyle ||
    proposalStatus === "In Progress";
  return !isNewQuestionnaire;
};

export {
  bindProposerAPIData,
  bindJointLifeAPIData,
  bindLoanDetailsAPIData,
  bindGeneralDetailsApiData,
  bindCovidAndNriDetails,
  bindMedicalLifestyleAPIData,
  bindProposerGeneralPayload,
  bindProposerAddressPayload,
  bindJointMemberPayload,
  bindProposerReviewData,
  bindJointLifeReviewData,
  handelIndianCurrencyChange,
  onChangeIndianCurrency,
  bindJointFreezePayload,
  bindJointFreezePayloadForRedux,
  bindProportionatePayload,
  maskUID,
  bindNewLeadDetailsApiData,
  handleUppercaseChange,
  bindAssignmentClauseApiData,
  bindAssignmentPayload,
  getQuestionnaireVersion
};
